<template>
  <div class="animated fadeIn">
    <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
    <b-card v-else>
      <Timer :formattedTime="formattedTime" />
      <template v-slot:header>
        <h5>Input Gadai Kendaraan</h5>
      </template>
      <b-form @submit.prevent="calculateMaksimumPinjaman">
        <div class="form-content-wrapper">
          <b-row>
            <b-col cols="9" sm="4">
              <h6 class="form-title">DATA ANGGOTA</h6>
            </b-col>
            <b-col cols="3" :hidden="$companyId == 'PGI' ? false : true">
              <b-badge
                :variant="pdfReadAnggota == false ? 'danger' : 'primary'"
                :hidden="seAnggota == null ? true : false"
                size="sm"
                @click="openModalSE(seAnggota, 'anggota', pdfReadAnggota)"
                v-b-tooltip.hover
                title="SE"
                name="jenisBarangViewBtn"
              >
                <i class="fa fa-info px-1"></i>
              </b-badge>
            </b-col>
          </b-row>
          <b-row class="no-gutters">
            <b-col cols="6" sm="3">
              <b-button
                @click="openSearchAnggotaModal"
                name="modalSearchAnggotaBtn"
                variant="pgiBtn"
                class="mr-2"
              >
                <i class="fa fa-search mr-2"></i>Pilih Anggota
              </b-button>
            </b-col>
            <b-col>
              <b-button @click="addAnggota" name="modalAddAnggotaBtn" variant="pgiBtn">
                <i class="fa fa-plus mr-2"></i>Anggota Baru
              </b-button>
            </b-col>
          </b-row>
          <StateDetailHandler
            :isLoading="stateListAnggota.isLoading"
            :isError="stateListAnggota.isError"
            :lines="5"
            @retry="getListAnggota(anggota.no)"
            class="mt-3"
          >
            <DetailSelectAnggota
              :anggota="anggota"
              :canEdit="IS_HAVE_PERMISSION_REQUEST_EDIT"
              :editAnggota="editAnggota"
              @refresh="getListAnggota"
              @preview-foto="openPreview"
              @wa="redirectToWhatsapp"
              @copy-wa="onCopyUrlWhatsApp"
              @edit="showEditAnggota"
              @detail="$bvModal.show('modal-detail-anggota')"
              @reset-password="$bvModal.show('modal-reset-password')"
              @edit-identitas="showEditIdentitas"
              @edit-anggota="showModalConfirmEditAnggota"
            />
          </StateDetailHandler>
          <div class="mb-4" v-show="valUmur == false">
            <span class="text-danger"
              ><i class="fa fa-warning"></i> Maaf umur nasabah belum 18 tahun, tidak bisa
              melakukan gadai.
            </span>
          </div>
        </div>
        <div class="form-content-wrapper">
          <h6 class="form-title">DATA KENDARAAN</h6>
          <b-form-group label="Tipe Pinjaman">
            <div class="d-flex">
              <b-form-radio
                class="mr-3"
                v-model="input.isBpkb"
                value="true"
                @change="checkTipePinjaman"
                >BPKB Saja</b-form-radio
              >
              <!-- <b-form-radio
                v-model="input.isBpkb"
                name="gadaiTipePinjaman"
                value="false"
                @change="checkTipePinjaman"
                >Kendaraan + BPKB</b-form-radio
              > -->
            </div>
          </b-form-group>
          <b-alert :show="showAlertEditAnggota" variant="warning">
            <div>
              <p>* Data Anggota anda belum lengkap, Silakan lengkapi terlebih dahulu</p>

              <div>
                <span v-if="dataKosong.namaAyah == null"> | Ayah </span>
                <span v-if="dataKosong.noHandphoneAyah == null"> | No Ayah </span>
                <span v-if="dataKosong.namaIbu == null"> | Ibu </span>
                <span v-if="dataKosong.noHandphoneIbu == null"> | No Ibu </span>
                <span v-if="dataKosong.namaPihakLain == null"> | Nama Pihak Lain </span>
                <span v-if="dataKosong.hubunganPihakLain == null">
                  | Hubungan Pihak Lain
                </span>
                <span v-if="dataKosong.noHandphonePihakLain == null">
                  | No Hp Pihak Lain
                </span>
                <span v-if="dataKosong.kotaPihakLain == null"> | Kota Pihak Lain </span>
                <span v-if="dataKosong.kecamatanPihakLain == null">
                  | Kecamatan Pihak Lain
                </span>
                <span v-if="dataKosong.kelurahanDesaPihakLain == null">
                  | Kelurahan Pihak Lain
                </span>
                <span v-if="dataKosong.rtPihakLain == null"> | Rt Pihak Lain </span>
                <span v-if="dataKosong.rwPihakLain == null"> | Rw Pihak Lain </span>
                <span v-if="dataKosong.alamatPihakLain == null">
                  | Alamat Pihak Lain
                </span>
                <span v-if="dataKosong.nomorGang == null"> | Nomor / Nama Gang </span>
                <span v-if="dataKosong.nomorRumah == null"> | Nomor Rumah </span>
                <span v-if="dataKosong.fotoFormDataBpkb == null">
                  | Foto Form Data BPKB
                </span>
              </div>
            </div>
            <b-button
              variant="pgiBtn"
              class="mt-3"
              @click="$bvModal.show('modal-edit-anggota')"
              ><i class="fa fa-pencil mr-2"></i>Edit Anggota</b-button
            >
          </b-alert>
          <b-row>
            <b-col cols="12" sm="5">
              <b-form-group label="Jenis Kendaraan">
                <b-row no-gutters>
                  <b-col>
                    <multiselect
                      v-model="input.jenisKendaraan"
                      :options="optKendaraanJenis"
                      :internal-search="true"
                      :allow-empty="false"
                      deselect-label=""
                      select-label=""
                      label="name"
                      track-by="id"
                      placeholder="-- Please select an option --"
                    />
                  </b-col>
                  <b-col
                    cols="3"
                    class="ml-2"
                    :hidden="$companyId != 'PGI' ? true : false"
                  >
                    <b-badge
                      :hidden="seJenis == null"
                      :variant="pdfReadJenis == false ? 'danger' : 'primary'"
                      @click="openModalSE(seJenis, 'jenis', pdfReadJenis)"
                      v-b-tooltip.hover
                      title="SE"
                      name="jenisKendaraanViewBtn"
                    >
                      <i class="fa fa-info px-1"></i>
                    </b-badge>
                  </b-col>
                </b-row>
              </b-form-group>
              <b-form-group label="Merk Kendaraan">
                <b-row no-gutters>
                  <b-col>
                    <StateInputHandler
                      :isLoading="stateMerkKendaraan.isLoading"
                      :error="stateMerkKendaraan.error"
                      errorMessage="Gagal memuat merk kendaraan."
                      @retry="getMerkKendaraan"
                    >
                      <multiselect
                        v-model="input.merkKendaraan"
                        :disabled="isEmptyState(input.jenisKendaraan) || optKendaraanMerk.length == 0"
                        :options="optKendaraanMerk"
                        :internal-search="true"
                        :allow-empty="false"
                        deselect-label=""
                        select-label=""
                        label="name"
                        track-by="id"
                        placeholder="-- Please select an option --"
                      />

                      <EmptyStateInput v-if="!isEmptyState(input.jenisKendaraan) && optKendaraanMerk.length == 0" />
                    </StateInputHandler>
                  </b-col>
                  <b-col
                    cols="3"
                    class="ml-2"
                    :hidden="$companyId != 'PGI' ? true : false"
                  >
                    <b-badge
                      :hidden="seMerk == null"
                      :variant="pdfReadMerk == false ? 'danger' : 'primary'"
                      size="sm"
                      @click="openModalSE(seMerk, 'merk', pdfReadMerk)"
                      v-b-tooltip.hover
                      title="SE"
                      name="jenisKendaraanViewBtn"
                    >
                      <i class="fa fa-info px-1"></i>
                    </b-badge>
                  </b-col>
                </b-row>
              </b-form-group>
              <b-form-group label="Tipe Kendaraan">
                <b-row no-gutters>
                  <b-col>
                    <StateInputHandler
                      :isLoading="stateTipeKendaraan.isLoading"
                      :error="stateTipeKendaraan.error"
                      errorMessage="Gagal memuat tipe kendaraan."
                      @retry="getTipeKendaraan"
                    >
                      <multiselect
                        name="gadaiTipeKendaraan"
                        v-model="input.tipeKendaraan"
                        :disabled="isEmptyState(input.merkKendaraan) || optKendaraanTipe.length == 0"
                        :options="optKendaraanTipe"
                        :internal-search="true"
                        :allow-empty="true"
                        deselect-label=""
                        select-label=""
                        label="name"
                        track-by="name"
                        placeholder="-- Please select an option --"
                      />

                      <EmptyStateInput v-if="!isEmptyState(input.merkKendaraan) && optKendaraanTipe.length == 0" />
                    </StateInputHandler>
                  </b-col>
                  <b-col
                    cols="3"
                    class="ml-2"
                    :hidden="$companyId != 'PGI' ? true : false"
                  >
                    <b-badge
                      :hidden="seTipe == null"
                      :variant="pdfReadTipe == false ? 'danger' : 'primary'"
                      size="sm"
                      @click="openModalSE(seTipe, 'tipe', pdfReadTipe)"
                      v-b-tooltip.hover
                      title="SE"
                      name="jenisBarangViewBtn"
                    >
                      <i class="fa fa-info px-1"></i>
                    </b-badge>
                  </b-col>
                </b-row>
              </b-form-group>
              <b-form-group label="Tahun">
                <b-row no-gutters>
                  <b-col>
                    <StateInputHandler
                      :isLoading="stateGradeKendaraan.isLoading || stateTahunKendaraan.isLoading || isLoadingHasTahun"
                      :error="stateTahunKendaraan.error"
                      errorMessage="Gagal memuat tahun kendaraan."
                      @retry="getTahunKendaraan"
                    >
                      <b-form-select
                        v-model="input.tahunKendaraan"
                        name="gadaiTahunKendaraan"
                        :disabled="isEmptyState(input.tipeKendaraan) || optKendaraanTahun.length == 0"
                      >
                        <template v-slot:first>
                          <b-form-select-option :value="null" disabled
                            >-- Please select an option --</b-form-select-option
                          >
                          <b-form-select-option
                            v-for="(item, idx) in optKendaraanTahun"
                            v-bind:value="{ id: item.id, name: item.name }"
                            v-bind:key="idx"
                          >
                            {{ item.name }}
                          </b-form-select-option>
                        </template>
                      </b-form-select>

                      <EmptyStateInput v-if="!isEmptyState(input.tipeKendaraan) && optKendaraanTahun.length == 0" />
                    </StateInputHandler>
                  </b-col>
                  <b-col
                    cols="3"
                    class="ml-2"
                    :hidden="$companyId != 'PGI' ? true : false"
                  >
                    <b-badge
                      :hidden="seTahun == null"
                      :variant="pdfReadTahun == false ? 'danger' : 'primary'"
                      size="sm"
                      @click="openModalSE(seTahun, 'tahun', pdfReadTahun)"
                      v-b-tooltip.hover
                      title="SE"
                      name="jenisKendaraanViewBtn"
                    >
                      <i class="fa fa-info px-1"></i>
                    </b-badge>
                  </b-col>
                </b-row>
              </b-form-group>
              <b-form-group label="Kondisi / Grade Kendaraan">
                <b-row no-gutters>
                  <b-col>
                    <StateInputHandler
                      :isLoading="stateGradeKendaraan.isLoading || stateTahunKendaraan.isLoading || isLoadingHasTahun"
                      :error="stateGradeKendaraan.error"
                      errorMessage="Gagal memuat kondisi / grade kendaraan."
                      @retry="getGradeKendaraan"
                    >
                      <b-form-select
                        v-model="input.kondisiKendaraan"
                        name="gadaiKondisiKendaraan"
                        :disabled="isEmptyState(input.tipeKendaraan) || optKendaraanKondisi.length == 0"
                      >
                        <template v-slot:first>
                          <b-form-select-option :value="null" disabled
                            >-- Please select an option --</b-form-select-option
                          >
                          <b-form-select-option
                            v-for="(item, idx) in optKendaraanKondisi"
                            v-bind:value="{ value: item.value, text: item.text }"
                            v-bind:key="idx"
                          >
                            {{ item.text }}
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                      
                      <EmptyStateInput v-if="!isEmptyState(input.tipeKendaraan) && optKendaraanKondisi.length == 0" />
                    </StateInputHandler>
                  </b-col>

                  <b-col
                    cols="3"
                    class="ml-2"
                    :hidden="$companyId == 'PGI' ? false : true"
                  >
                    <b-badge
                      :variant="pdfReadKondisi == false ? 'danger' : 'primary'"
                      :hidden="seKondisi != null && showSeKondisi == true ? false : true"
                      size="sm"
                      @click="openModalSE(seKondisi, 'kondisi', pdfReadKondisi)"
                      v-b-tooltip.hover
                      title="SE"
                      name="jenisBarangViewBtn"
                    >
                      <i class="fa fa-info px-1"></i>
                    </b-badge>
                  </b-col>
                </b-row>
              </b-form-group>
              <b-form-group label="Warna Kendaraan">
                <b-row class="no-gutters">
                  <b-col>
                    <b-form-select
                      v-model="input.warnaKendaraan"
                      name="gadaiWarnaKendaraan"
                      :options="optKendaraanWarna"
                      value-field="id"
                      text-field="name"
                    >
                      <template v-slot:first>
                        <b-form-select-option :value="null" disabled
                          >-- Please select an option --</b-form-select-option
                        >
                      </template>
                    </b-form-select>
                  </b-col>
                  <b-col
                    class="ml-2"
                    cols="3"
                    :hidden="
                      seWarnaKendaraan == null || $companyId != 'PGI' ? true : false
                    "
                  >
                    <b-badge
                      :variant="pdfReadWarnaKendaraan == false ? 'danger' : 'primary'"
                      size="sm"
                      @click="
                        openModalSE(
                          seWarnaKendaraan,
                          'WarnaKendaraan',
                          pdfReadWarnaKendaraan
                        )
                      "
                      v-b-tooltip.hover
                      title="SE"
                      name="jenisBarangViewBtn"
                    >
                      <i class="fa fa-info px-1"></i>
                    </b-badge>
                    <b-link
                      :to="`${$route.path}/surat-edaran/7`"
                      class="ml-2"
                      :hidden="
                        $companyId == 'PGI' && role == 'Super Admin' ? false : true
                      "
                    >
                      <b-badge
                        size="sm"
                        class="table-button view"
                        v-b-tooltip.hover
                        title="Setting SE Warna Kendaraan"
                        name="jenisBarangViewBtn"
                      >
                        <i class="fa fa-plus"></i>
                      </b-badge>
                    </b-link>
                  </b-col>
                </b-row>
              </b-form-group>
              <b-form-group label="Status Kendaraan">
                <b-row class="no-gutters">
                  <b-col>
                    <b-form-select
                      v-model="input.statusKendaraan"
                      name="gadaiStatusKendaraan"
                    >
                      <template v-slot:first>
                        <b-form-select-option :value="null" disabled
                          >-- Please select an option --</b-form-select-option
                        >
                      </template>
                      <b-form-select-option value="Ada Faktur"
                        >Ada Faktur</b-form-select-option
                      >
                      <b-form-select-option value="Tanpa Faktur"
                        >Tanpa Faktur</b-form-select-option
                      >
                    </b-form-select>
                  </b-col>
                  <b-col
                    class="ml-2"
                    cols="3"
                    :hidden="
                      seStatusKendaraan == null || $companyId != 'PGI' ? true : false
                    "
                  >
                    <b-badge
                      :variant="pdfReadStatusKendaraan == false ? 'danger' : 'primary'"
                      size="sm"
                      @click="
                        openModalSE(
                          seStatusKendaraan,
                          'StatusKendaraan',
                          pdfReadStatusKendaraan
                        )
                      "
                      v-b-tooltip.hover
                      title="SE"
                      name="jenisBarangViewBtn"
                    >
                      <i class="fa fa-info px-1"></i>
                    </b-badge>
                    <b-link
                      :to="`${$route.path}/surat-edaran/8`"
                      class="ml-2"
                      :hidden="
                        $companyId == 'PGI' && role == 'Super Admin' ? false : true
                      "
                    >
                      <b-badge
                        size="sm"
                        class="table-button view"
                        v-b-tooltip.hover
                        title="Setting SE Status Kendaraan"
                        name="jenisBarangViewBtn"
                      >
                        <i class="fa fa-plus"></i>
                      </b-badge>
                    </b-link>
                  </b-col>
                </b-row>
              </b-form-group>
              <b-form-group label="No. Polisi" :description="textCreatedNopol">
                <b-form-input
                  v-model="input.noPolisi"
                  name="gadaiNoPolisi"
                  hidden
                  required
                ></b-form-input>
                <b-row class="no-gutters">
                  <b-col class="mr-2">
                    <b-form-select
                      v-model="boxSatu"
                      :options="wilayahList"
                      required
                      class="text-uppercase"
                      @change="boxNoPolisiSatu"
                    />
                  </b-col>
                  <b-col class="mr-2">
                    <b-form-input
                      style="text-transform: uppercase"
                      minlength="1"
                      maxlength="4"
                      required
                      v-model="boxDua"
                      v-on:keyup="boxNoPolisiDua"
                      @paste.prevent
                    ></b-form-input>
                  </b-col>
                  <b-col class="mr-2">
                    <b-form-input
                      style="text-transform: uppercase"
                      minlength="1"
                      maxlength="3"
                      required
                      v-model="boxTiga"
                      v-on:keyup="boxNoPolisiTiga"
                      @paste.prevent
                    ></b-form-input>
                  </b-col>
                  <b-col class="" cols="3">
                    <b-badge
                      :variant="pdfReadNoPolisi == false ? 'danger' : 'primary'"
                      :hidden="seNoPolisi == null ? true : false"
                      size="sm"
                      @click="openModalSE(seNoPolisi, 'NoPolisi', pdfReadNoPolisi)"
                      v-b-tooltip.hover
                      title="SE"
                      name="jenisBarangViewBtn"
                    >
                      <i class="fa fa-info px-1"></i>
                    </b-badge>
                    <b-link
                      :to="`${$route.path}/surat-edaran/9`"
                      class="ml-2"
                      :hidden="
                        $companyId == 'PGI' && role == 'Super Admin' ? false : true
                      "
                    >
                      <b-badge
                        size="sm"
                        class="table-button view"
                        v-b-tooltip.hover
                        title="Setting SE No. Polisi"
                        name="jenisBarangViewBtn"
                      >
                        <i class="fa fa-plus"></i>
                      </b-badge>
                    </b-link>
                  </b-col>
                </b-row>
              </b-form-group>
              <b-form-group v-model="input.noPolisi"></b-form-group>
            </b-col>
          </b-row>

          <b-form-group>
            <label>Kelengkapan Kendaraan</label>
            <span
              v-if="optKelengkapanKendaraan.length != 0"
              :hidden="$companyId == 'PGI' ? false : true"
            >
              <b-badge
                :variant="pdfReadKelengkapan == false ? 'danger' : 'primary'"
                :hidden="seKelengkapan == null ? true : false"
                size="sm"
                @click="openModalSE(seKelengkapan, 'kelengkapan', pdfReadKelengkapan)"
                v-b-tooltip.hover
                title="SE"
                name="jenisBarangViewBtn"
              >
                <i class="fa fa-info px-1"></i>
              </b-badge>
            </span>
            <StateCheckboxHandler
              :isLoading="stateKelengkapanKendaraan.isLoading"
              :error="stateKelengkapanKendaraan.error"
              errorMessage="Gagal memuat kelengkapan kendaraan."
              @retry="getKelengkapanKendaraan"
            >
              <template v-if="optKelengkapanKendaraan.length > 0">
                <b-form-checkbox-group
                  class="checkbox-group"
                  v-model="input.kelengkapanKendaraan"
                  name="gadaiKelengkapanKendaraan"
                >
                  <b-form-checkbox
                    v-for="item in optKelengkapanKendaraan"
                    v-bind:key="item.id"
                    :value="{ id: item.id, name: item.name }"
                  >
                    {{ item.name }}
                  </b-form-checkbox>
                </b-form-checkbox-group>
              </template>
              <template v-else>
                <div class="text-muted">
                  Tidak ada kelengkapan dari jenis kendaraan yang dipilih.
                </div>
              </template>
            </StateCheckboxHandler>
          </b-form-group>
          <b-form-group label="Spesifikasi Kendaraan (Jenis)">
            <b-row>
              <b-col md="6">
                <span class="text-muted">Penambahan</span>
                <StateCheckboxHandler
                  :isLoading="stateSpesifikasiJenisKendaraan.isLoading"
                  :error="stateSpesifikasiJenisKendaraan.error"
                  errorMessage="Gagal memuat spesifikasi jenis kendaraan."
                  @retry="getSpesifikasiJenisKendaraan"
                >
                  <template v-if="optKendaraanSpekJenis.penambahan.length > 0">
                    <b-form-checkbox-group
                      class="checkbox-group mt-1"
                      v-model="input.spesifikasiKendaraanJenis"
                      name="gadaiPenambahanSpekJenisBarangKend"
                    >
                      <div v-for="item in optKendaraanSpekJenis.penambahan" class="d-block">
                        <b-row>
                          <b-col cols="10">
                            <b-form-checkbox v-bind:key="item.id" :value="item.id">
                              {{ item.name }}
                            </b-form-checkbox>
                          </b-col>
                          <b-col cols="2" :hidden="$companyId == 'PGI' ? false : true">
                            <b-badge
                              :variant="item.isViewSE == false ? 'danger' : 'primary'"
                              :hidden="item.se == null ? true : false"
                              @click="
                                openModalSE(
                                  item.se,
                                  'spesifikasiJenis',
                                  item.isViewSE,
                                  'penambahanSpekJenis',
                                  item.id
                                )
                              "
                              v-b-tooltip.hover
                              title="SE"
                              name="jenisBarangViewBtn"
                            >
                              <i class="fa fa-info px-1"></i>
                            </b-badge>
                          </b-col>
                        </b-row>
                      </div>
                    </b-form-checkbox-group>
                  </template>
                  <template v-else>
                    <div class="text-muted mb-2">
                      Tidak ada penambahan spesifikasi dari jenis kendaraan yang dipilih.
                    </div>
                  </template>
                </StateCheckboxHandler>
              </b-col>
              <b-col md="6">
                <span class="text-muted">Pengurangan</span>
                <StateCheckboxHandler
                  :isLoading="stateSpesifikasiJenisKendaraan.isLoading"
                  :error="stateSpesifikasiJenisKendaraan.error"
                  errorMessage="Gagal memuat spesifikasi jenis kendaraan."
                  @retry="getSpesifikasiJenisKendaraan"
                >
                  <template v-if="optKendaraanSpekJenis.pengurangan.length > 0">
                    <b-form-checkbox-group
                      class="checkbox-group mt-1"
                      v-model="input.spesifikasiKendaraanJenis"
                      name="gadaiPenambahanSpekJenisBarangKend"
                    >
                      <div v-for="item in optKendaraanSpekJenis.pengurangan" class="d-block">
                        <b-row>
                          <b-col cols="10">
                            <b-form-checkbox
                              v-bind:key="item.id"
                              :value="item.id"
                              :disabled="
                                item.name == 'Pajak Mati (a/n Sendiri)' ||
                                item.name == 'Pajak Mati (a/n Orang lain)' ||
                                item.name == 'Pajak Mati (a/n SENDIRI)' ||
                                item.name == 'Pajak Mati (a/n ORANG LAIN)' ||
                                item.name == 'Pajak Mati (a/n Sendiri Pick Up)' ||
                                item.name == 'Pajak Mati (a/n Orang Lain Pick Up)' ||
                                item.name == 'Pajak Mati (a/n SENDIRI PICK UP)' ||
                                item.name == 'Pajak Mati (a/n ORANG LAIN PICK UP)'
                              "
                            >
                              {{ item.name }}
                            </b-form-checkbox>
                          </b-col>
                          <b-col cols="2" :hidden="$companyId == 'PGI' ? false : true">
                            <b-badge
                              :variant="item.isViewSE == false ? 'danger' : 'primary'"
                              :hidden="item.se == null ? true : false"
                              @click="
                                openModalSE(
                                  item.se,
                                  'spesifikasiJenis',
                                  item.isViewSE,
                                  'penguranganSpekJenis',
                                  item.id
                                )
                              "
                              v-b-tooltip.hover
                              title="SE"
                              name="jenisBarangViewBtn"
                            >
                              <i class="fa fa-info px-1"></i>
                            </b-badge>
                          </b-col>
                        </b-row>
                      </div>
                    </b-form-checkbox-group>
                  </template>
                  <template v-else>
                    <div class="text-muted mb-2">
                      Tidak ada pengurangan spesifikasi dari jenis kendaraan yang dipilih.
                    </div>
                  </template>
                </StateCheckboxHandler>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group label="Spesifikasi Kendaraan (Merk)">
            <b-row>
              <b-col md="6">
                <span class="text-muted">Penambahan</span>
                <StateCheckboxHandler
                  :isLoading="stateSpesifikasiMerkKendaraan.isLoading"
                  :error="stateSpesifikasiMerkKendaraan.error"
                  errorMessage="Gagal memuat spesifikasi merk kendaraan."
                  @retry="getSpesifikasiMerkKendaraan"
                >
                  <template v-if="optKendaraanSpekMerk.penambahan.length > 0">
                    <b-form-checkbox-group
                      class="checkbox-group mt-1"
                      v-model="input.spesifikasiKendaraanMerk"
                      name="gadaiPenambahanSpekMerkBarangKend"
                    >
                      <div v-for="item in optKendaraanSpekMerk.penambahan" class="d-block">
                        <b-row>
                          <b-col cols="10">
                            <b-form-checkbox v-bind:key="item.id" :value="item.id">
                              {{ item.name }}
                            </b-form-checkbox>
                          </b-col>
                          <b-col cols="2" :hidden="$companyId == 'PGI' ? false : true">
                            <b-badge
                              :variant="item.isViewSE == false ? 'danger' : 'primary'"
                              :hidden="item.se == null ? true : false"
                              @click="
                                openModalSE(
                                  item.se,
                                  'spesifikasiMerk',
                                  item.isViewSE,
                                  'penambahanSpekMerk',
                                  item.id
                                )
                              "
                              v-b-tooltip.hover
                              title="SE"
                              name="jenisBarangViewBtn"
                            >
                              <i class="fa fa-info px-1"></i>
                            </b-badge>
                          </b-col>
                        </b-row>
                      </div>
                    </b-form-checkbox-group>
                  </template>
                  <template v-else>
                    <div class="text-muted mb-2">
                      Tidak ada penambahan spesifikasi dari merk kendaraan yang dipilih.
                    </div>
                  </template>
                </StateCheckboxHandler>
              </b-col>
              <b-col md="6">
                <span class="text-muted">Pengurangan</span>
                <StateCheckboxHandler
                  :isLoading="stateSpesifikasiMerkKendaraan.isLoading"
                  :error="stateSpesifikasiMerkKendaraan.error"
                  errorMessage="Gagal memuat spesifikasi merk kendaraan."
                  @retry="getSpesifikasiMerkKendaraan"
                >
                  <template v-if="optKendaraanSpekMerk.pengurangan.length > 0">
                    <b-form-checkbox-group
                      class="checkbox-group mt-1"
                      v-model="input.spesifikasiKendaraanMerk"
                      name="gadaiPenguranganSpekMerkBarangKend"
                    >
                      <div v-for="item in optKendaraanSpekMerk.pengurangan" class="d-block">
                        <b-row>
                          <b-col cols="10">
                            <b-form-checkbox v-bind:key="item.id" :value="item.id">
                              {{ item.name }}
                            </b-form-checkbox>
                          </b-col>
                          <b-col cols="2" :hidden="$companyId == 'PGI' ? false : true">
                            <b-badge
                              :variant="item.isViewSE == false ? 'danger' : 'primary'"
                              :hidden="item.se == null ? true : false"
                              @click="
                                openModalSE(
                                  item.se,
                                  'spesifikasiMerk',
                                  item.isViewSE,
                                  'penguranganSpekMerk',
                                  item.id
                                )
                              "
                              v-b-tooltip.hover
                              title="SE"
                              name="jenisBarangViewBtn"
                            >
                              <i class="fa fa-info px-1"></i>
                            </b-badge>
                          </b-col>
                        </b-row>
                      </div>
                    </b-form-checkbox-group>
                  </template>
                  <template v-else>
                    <div class="text-muted mb-2">
                      Tidak ada pengurangan spesifikasi dari merk kendaraan yang dipilih.
                    </div>
                  </template>
                </StateCheckboxHandler>
              </b-col>
            </b-row>
          </b-form-group>
        </div>

        <DataStnk
          :dataStnk="input.dataStnk"
          :anggota="anggota"
          :copyStnk="copyStnk"
          :jenisKendaraan="input.jenisKendaraan"
          :kondisi="input.kondisiKendaraan"
        ></DataStnk>

        <div class="form-content-wrapper">
          <h6 class="form-title">DATA BPKB</h6>
          <b-form-group label="No. BPKB">
            <b-form-input
              v-model="input.noBpkb"
              name="gadaiNoBpkb"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group label="BPKB Atas Nama">
            <b-form-input
              v-model="input.namaBpkb"
              name="gadaiNamaBpkb"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group label="No. Mesin">
            <b-form-input
              v-model="input.noMesin"
              name="gadaiNoMesin"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group label="No. Rangka">
            <b-form-input
              v-model="input.noRangka"
              name="gadaiNoRangka"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="form-content-wrapper">
          <h6 class="form-title">DATA PENDUKUNG</h6>
          <div>
            <b-button
              variant="pgiBtn"
              :hidden="input.isBpkb == true"
              class="mb-2"
              @click="addFotoPendukung"
              name="fotoPendukungAddBtn"
              ><i class="fa fa-plus mr-2"></i>Foto Pendukung</b-button
            >
            <div class="text-danger mt-2 mb-2" v-show="fotoPendukungError">
              * Foto Pendukung Maksimal 6 Foto
            </div>
            <FotoPendukungInputKendaraan
              v-for="item in input.fotoPendukung"
              :name="item.name"
              :index="item.index"
              :isBpkb="input.isBpkb"
              v-bind:key="item.index"
              :fotoPendukung="item"
              :length="input.fotoPendukung.length"
              :minLength="minLengthFotoPendukung"
              :lat="lat"
              :long="long"
              @remove="removeFotoPendukung"
              @showModalCam="openModalCam"
              @showModalPreview="openModalPreview"
            />
          </div>
        </div>
        <div class="form-content-wrapper">
          <h6 class="form-title">PROMO</h6>
          <b-button variant="cancelBtn" @click="checkPromo" :disabled="isGettingPromo">
            {{ isGettingPromo ? "Mengambil..." : "Cek Promo yang Dapat Digunakan" }}
            <i class="fa fa-search ml-2"></i>
          </b-button>
          <div class="detail-promo-data mt-4" v-if="!isGettingPromo && isPromoRetrieved">
            <div v-if="optPromo.length == 0" class="text-danger">
              * Tidak ada promo yang bisa digunakan untuk pemilihan barang gadai ini.
            </div>
            <b-form-checkbox-group v-else v-model="input.promo" name="promoList" stacked>
              <b-form-checkbox
                class="mb-1"
                v-for="item in optPromo"
                v-bind:key="item.id"
                :value="item.id"
                >{{ item.name }}</b-form-checkbox
              >
            </b-form-checkbox-group>
          </div>
        </div>
        <div
          class="form-content-wrapper"
          v-if="
            showDataLainnya &&
            input.merkKendaraan.name == 'Lainnya' &&
            input.tipeKendaraan.name == 'Lainnya'
          "
        >
          <h6 class="form-title">HARGA KENDARAAN LAINNYA</h6>
          <b-form-group label="Nominal Harga">
            <b-input-group prepend="Rp.">
              <b-form-input
                v-model="input.nominalHargaLainnya"
                name="nominalHargaLainnya"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
          <h6 class="form-title mt-4">ADMIN FEE LAINNYA</h6>
          <b-form-group label="Nominal Admin Fee">
            <b-input-group prepend="Rp.">
              <b-form-input
                v-model="input.nominalAdminFeeLainnya"
                name="nominalAdminFeeLainnya"
                required
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </div>
        <div class="form-wrapper-btn submit-btn-wrapper">
          <b-button
            type="submit"
            name="gadaiSubmitBtn"
            variant="primary"
            :disabled="isSubmitting"
          >
            {{ isSubmitting ? "Menghitung..." : "Hitung" }}
          </b-button>
        </div>
      </b-form>
      <b-modal
        id="modal-input-anggota"
        body-class="modal-nopadding"
        size="xl"
        title="Input Anggota"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
      >
        <InputAnggota
          :isModal="modalAnggota"
          :requiredForDataKerabatAndPihakLain="input.isBpkb"
          @submitModalAnggota="inputNewAnggota"
          :getListAnggota="getListAnggota"
        />
      </b-modal>
      <b-modal
        id="modal-edit-anggota"
        body-class="modal-nopadding"
        size="xl"
        title="Edit Anggota"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
      >
        <EditAnggota
          :isModal="modalAnggota"
          :idAnggota="anggota.id"
          :requiredForDataKerabatAndPihakLain="input.isBpkb"
          @updateModalAnggota="editNewAnggota"
          :getListAnggota="getListAnggota"
          :onToastSuccesEdit="onToastSuccesEdit"
        />
      </b-modal>
      <b-modal
        id="modal-detail-anggota"
        body-class="modal-nopadding"
        size="xl"
        title="Detail Anggota"
        no-close-on-backdrop
      >
        <DetailAnggota :isModal="modalAnggota" :idAnggota="anggota.id" />
        <template v-slot:modal-footer="{ cancel }">
          <b-button variant="secondary" name="cancelDetailAnggotaBtn" @click="cancel()">
            Tutup
          </b-button>
        </template>
      </b-modal>
      <ModalPilihAnggota @anggota-selected="selectAnggota" />
      <ModalRincian
        :namaLengkapBarang="namaLengkapBarang"
        :rincian="rincian"
        :isSubmitting="isSubmitting"
        @next="calculateConfirmation"
      />
      <ModalKonfirmasi
        :isSubmitting="isSubmitting"
        :nilaiPinjaman="input.nilaiPinjaman"
        :anggota="anggota"
        :rincian="rincian"
        :namaLengkapBarang="namaLengkapBarang"
        @exec-submit="submitGadai"
      />
      <ModalSukses :rincian="rincian" @done="reset" />
      <ModalWebCam idWebcam="webcam-input-kend" @photoTaken="setResult" />
      <ModalPreview modalId="modal-preview-gadai" :fotoPreview="activeFotoPreview" />

      <b-modal
        id="modal-info-update"
        title="Update Data Anggota"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
      >
        <p>
          Mohon klik tombol Edit Anggota dan pastikan data anggota sudah sesuai dengan
          kartu identitas anggota!
        </p>
        <p>
          <strong>
            Pastikan alamat (kota, kecamatan, kelurahan) dan foto identitas sudah benar.
          </strong>
        </p>
        <p>
          Catatan: Bila data sudah benar semua dari awal, mohon untuk tetap menekan tombol
          Update ketika Edit Anggota.
        </p>
        <b-button variant="pgiBtn" class="mr-2" @click="showModalEditAnggota()">
          <i class="fa fa-pencil mr-2"></i>
          Edit Anggota
        </b-button>
      </b-modal>
      <b-modal
        id="modal-upgrade-member"
        title="Upgrade Member"
        centered
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
      >
        Melakukan upgrade nasabah a/n
        <strong>{{ anggota.nama }} ({{ anggota.no }})</strong> menjadi member.
        <div class="mt-4 text-right">
          <b-button
            variant="pgiBtn"
            :disabled="isSubmitting"
            @click="confirmUpgradeMember"
          >
            Upgrade Member
          </b-button>
        </div>
      </b-modal>
      <b-modal
        id="modal-confirm-upgrade"
        title="Konfirmasi"
        centered
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
      >
        Konfirmasi upgrade nasabah a/n
        <strong>{{ anggota.nama }} ({{ anggota.no }})</strong> menjadi member?
        <div class="mt-4 text-right">
          <b-button variant="pgiBtn" :disabled="isSubmitting" @click="execUpgradeMember">
            {{ isSubmitting ? "Mengupgrade..." : "Upgrade" }}
          </b-button>
        </div>
      </b-modal>
      <ModalResetPassword :nasabah="anggota" />

      <!-- MODAL SHOW SE -->
      <b-modal id="modal-SE" class="surat_edaran_modal" size="lg" title="Surat Edaran">
        <b-table
          bordered
          hover
          show-empty
          :fields="fields"
          :busy="false"
          :items="activeSE"
          :currentPage="currentPage"
          :perPage="perPage"
          :borderless="true"
          :head-variant="null"
          responsive
          class="mb-3"
        >
          <template v-slot:header :hidden="true"></template>
          <template v-slot:cell(se)="row">
            <iframe
              width="100%"
              height="700"
              allowfullscreen
              :src="$baseFilePath + row.item.filepath"
              frameborder="0"
            ></iframe>
          </template>
        </b-table>
        <div class="pagination-wrapper d-flex align-items-center justify-content-center">
          <b-pagination
            class="mb-0"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
            @input="onPageChange"
          ></b-pagination>
        </div>
        <template #modal-footer>
          <div class="w-100"></div>
        </template>
      </b-modal>

      <!-- MODAL SHOW SE Load -->
      <b-modal
        id="modal-SE-load"
        class="surat_edaran_modal"
        size="lg"
        title="Surat Edaran"
      >
        <b-table
          id="tableSE"
          bordered
          hover
          show-empty
          :fields="fields"
          :busy="false"
          :items="activeSE"
          :currentPage="currentPage"
          :perPage="perPage"
          :borderless="true"
          :head-variant="null"
          responsive
          class="mb-3"
        >
          <template v-slot:header :hidden="true"></template>
          <template v-slot:cell(se)="row">
            <iframe
              width="100%"
              height="700"
              allowfullscreen
              :src="$baseFilePath + row.item.filepath"
              frameborder="0"
            ></iframe>
          </template>
        </b-table>
        <template>
          <div class="progress" :hidden="progress == 100 || progress == 0 ? true : false">
            <div
              class="progress-bar"
              role="progressbar"
              :style="{ width: progress + '%' }"
              :aria-valuenow="progress"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {{ progress }}%
            </div>
          </div>
        </template>
        <br />
        <div class="pagination-wrapper d-flex align-items-center justify-content-center">
          <b-pagination
            class="mb-0"
            :disabled="interval"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
            @input="onPageChange"
          ></b-pagination>
        </div>
        <template #modal-footer>
          <div class="w-100"></div>
        </template>
      </b-modal>

      <b-modal
        id="modal-confirm-lanjutGadai"
        title="Confirm Info Gadai"
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
      >
        <p class="mb-0">
          Mohon informasikan IG terlebih dahulu mengenai data mobil yang akan digadaikan.
          Hanya lanjutkan apabila pihak IG sudah memberikan perintah untuk melanjutkan
          input gadai.
        </p>
        <template v-slot:modal-footer="{ cancel }">
          <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
            Lanjutkan Gadai
          </b-button>
        </template>
      </b-modal>

      <ModalResetPassword :nasabah="anggota" />

      <b-modal
        id="modal-update-telepon"
        title="Mohon update no telepon anggota"
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
      >
        <p class="mb-0">Mohon untuk mengupdate no telepon anggota terlebih dahulu !</p>
        <template v-slot:modal-footer="{ cancel }">
          <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
            Lanjutkan Gadai
          </b-button>
        </template>
      </b-modal>
    </b-card>

    <ModalIdentitas
      :isModal="modalAnggota"
      :idAnggota="anggota.id"
      :dataAnggota="anggota"
      :getListAnggota="getListAnggota"
      :isEdit="isModalEditAnggota"
      titleInformasiEdit="Perubahan identitas dapat dilakukan melalui tombol Edit Identitas di depan."
    />

    <ModalConfirm id="modal-request-edit-no-handphone" title="Konfirmasi Perubahan No Handphone Anggota"
      :isSubmitting="isLoadingReqApproval" desc="Apakah Anda yakin ingin ubah no handphone anggota ini?"
      @submit="handleApproval('no-handphone')" />

    <ModalConfirm id="modal-request-edit-name" title="Konfirmasi Perubahan Nama Anggota" :isSubmitting="isLoadingReqApproval"
      desc="Apakah Anda yakin ingin ubah nama anggota ini?" @submit="handleApproval('name')" />
  </div>
</template>

<script>
import ModalPilihAnggota from "../ModalPilihAnggota";
import ModalRincian from "../ModalRincian";
import ModalKonfirmasi from "../ModalKonfirmasi";
import ModalSukses from "../ModalSukses";
import InputAnggota from "../../master/anggota/InputAnggota";
import EditAnggota from "../../master/anggota/EditAnggota";
import DetailAnggota from "../../master/anggota/DetailAnggota";
import FotoPendukungInputKendaraan from "../../../components/webcam/FotoPendukungInputKendaraan";
import ModalWebCam from "../../../components/webcam/ModalWebCam";
import ModalPreview from "../../../components/webcam/ModalPreview";
import ModalResetPassword from "../../master/anggota/ModalResetPassword";
import DataStnk from "../../../components/anggota/DataStnk";
import Timer from "@/components/gadai/Timer";
import ModalIdentitas from "../ModalIdentitas.vue";
import StateInputHandler from '@/components/common/StateInputHandler'
import StateCheckboxHandler from '@/components/common/StateCheckboxHandler'
import EmptyStateInput from '@/components/common/EmptyStateInput'
import StateDetailHandler from '@/components/common/StateDetailHandler'
import DetailSelectAnggota from '@/components/anggota/DetailSelectAnggota'

export default {
  name: "input-gadai-kendaraan",
  components: {
    ModalPilihAnggota,
    ModalRincian,
    ModalKonfirmasi,
    ModalSukses,
    InputAnggota,
    EditAnggota,
    DetailAnggota,
    FotoPendukungInputKendaraan,
    ModalWebCam,
    ModalPreview,
    DataStnk,
    ModalResetPassword,
    Timer,
    ModalIdentitas,
    StateInputHandler,
    StateCheckboxHandler,
    EmptyStateInput,
    StateDetailHandler,
    DetailSelectAnggota
  },
  data() {
    return {
      role: null,
      initStatus: 0,
      isGettingPromo: false,
      isPromoRetrieved: false,
      isSubmitting: false,
      shouldResetSelections: false,

      lat: 0,
      long: 0,

      modalAnggota: true,
      showAlertEditAnggota: false,

      interval: false,
      progress: 0,
      intervalId: null,

      value: 70,
      max: 100,

      editAnggota: false,

      isFromSimulasi: false,
      anggota: {
        id: null,
        nama: "-",
        no: "-",
        noMember: null,
        jenisIdentitas: "-",
        noIdentitas: "-",
        noHp: "-",
        noRumah: "-",
        alamat: "-",
        isComplete: false,
        shouldUpdate: false,
        fotoKtp: "",
      },

      dataKosong: {
        namaAyah: null,
        noHandphoneAyah: null,
        namaIbu: null,
        noHandphoneAyah: null,
        namaPihakLain: null,
        hubunganPihakLain: null,
        noHandphonePihakLain: null,
        kotaPihakLain: null,
        kecamatanPihakLain: null,
        kelurahanDesaPihakLain: null,
        rtPihakLain: null,
        rwPihakLain: null,
        alamatPihakLain: null,
        nomorGang: null,
        nomorRumah: null,
        fotoFormDataBpkb: null,
      },

      rincian: {
        hargaBarang: 0,
        maksimumPinjaman: 0,
        minimumPinjaman: 0,
        perhitunganPromo: null,
        perhitunganKondisi: {},
        perhitunganSpek: [],
        perhitunganBonusGadaiPertama: {},
        perhitunganStatusAnggota: {},
        biayaAdmin: 0,
        noFaktur: "",
        showAlertNoFakturGanda: "false",
        alertNoPol: "",
        alertNoFakturGanda: "",
        alertNoMesin: "",
        alertGadai: "kend",
        disburseType: 0,
      },

      namaLengkapBarang: "",

      input: {
        isBpkb: true,
        jenisKendaraan: { id: null, name: null },
        merkKendaraan: { id: null, name: null },
        tipeKendaraan: null,
        tahunKendaraan: null,
        kondisiKendaraan: null,
        warnaKendaraan: null,
        statusKendaraan: "",
        kelengkapanKendaraan: [],
        spesifikasiKendaraanJenis: [],
        spesifikasiKendaraanMerk: [],
        noPolisi: "",
        dataStnk: {
          namaStnk: "",
          kotaStnk: "",
          kotaStnkId: "",
          kecamatanStnk: null,
          kelurahanDesaStnk: null,
          alamatStnk: "",
          masaBerlakuStnk: "",
          submitMasaBerlakuStnk: "",
          rtStnk: "",
          rwStnk: "",
          copy: false,
        },
        noBpkb: "",
        namaBpkb: "",
        noMesin: "",
        noRangka: "",
        promo: [],
        nilaiPinjaman: 0,
        useVoucher: false,
        voucherCode: "",
        disburseType: 0,

        fotoPendukung: [
          {
            index: 0,
            id: 0,
            name: "Foto KTP",
            checkFotoBarangPendukung: false,
            fotoBarangPendukungPlaceholder: "Choose a file",
            fotoBarangPendukung: null,
            fotoBarangPendukungBase64: null,
            activeFotoPendukungBase64: null,
            require: true,
          },
          {
            index: 1,
            id: 0,
            name: "SS verifikasi WA (Terlihat no WA nasabah)",
            checkFotoBarangPendukung: false,
            fotoBarangPendukungPlaceholder: "Choose a file",
            fotoBarangPendukung: null,
            fotoBarangPendukungBase64: null,
            activeFotoPendukungBase64: null,
            require: true,
          },
          {
            index: 2,
            id: 0,
            name: "Foto BPKB halaman Identitas Pemilik",
            checkFotoBarangPendukung: false,
            fotoBarangPendukungPlaceholder: "Choose a file",
            fotoBarangPendukung: null,
            fotoBarangPendukungBase64: null,
            activeFotoPendukungBase64: null,
            require: true,
          },
          {
            index: 3,
            id: 0,
            name: " Foto BPKB halaman Identitas Motor",
            checkFotoBarangPendukung: false,
            fotoBarangPendukungPlaceholder: "Choose a file",
            fotoBarangPendukung: null,
            fotoBarangPendukungBase64: null,
            activeFotoPendukungBase64: null,
            require: true,
          },
          {
            index: 4,
            id: 0,
            name: "Foto BPKB halaman Identitas Perubahan (opsional)",
            checkFotoBarangPendukung: false,
            fotoBarangPendukungPlaceholder: "Choose a file",
            fotoBarangPendukung: null,
            fotoBarangPendukungBase64: null,
            activeFotoPendukungBase64: null,
            require: false,
          },
          {
            index: 5,
            id: 0,
            name: "Foto STNK tampak depan (pajak tahunan)",
            checkFotoBarangPendukung: false,
            fotoBarangPendukungPlaceholder: "Choose a file",
            fotoBarangPendukung: null,
            fotoBarangPendukungBase64: null,
            activeFotoPendukungBase64: null,
            require: true,
          },
          {
            index: 6,
            id: 0,
            name: "Foto STNK tampak belakang (pajak 5 tahun) (opsional)",
            checkFotoBarangPendukung: false,
            fotoBarangPendukungPlaceholder: "Choose a file",
            fotoBarangPendukung: null,
            fotoBarangPendukungBase64: null,
            activeFotoPendukungBase64: null,
            require: false,
          },
          {
            index: 7,
            id: 0,
            name: "Nasabah + Motor",
            checkFotoBarangPendukung: false,
            fotoBarangPendukungPlaceholder: "Choose a file",
            fotoBarangPendukung: null,
            fotoBarangPendukungBase64: null,
            activeFotoPendukungBase64: null,
            require: true,
          },
          {
            index: 8,
            id: 0,
            name: "Surat Pernyataan",
            checkFotoBarangPendukung: false,
            fotoBarangPendukungPlaceholder: "Choose a file",
            fotoBarangPendukung: null,
            fotoBarangPendukungBase64: null,
            activeFotoPendukungBase64: null,
            require: true,
          },
          {
            index: 9,
            id: 0,
            name: "Foto Kartu Keluarga (opsional)",
            checkFotoBarangPendukung: false,
            fotoBarangPendukungPlaceholder: "Choose a file",
            fotoBarangPendukung: null,
            fotoBarangPendukungBase64: null,
            activeFotoPendukungBase64: null,
            require: false,
          },
        ],

        nominalHargaLainnya: null,
        nominalAdminFeeLainnya: null,
      },

      indexFotoPendukung: 1,
      fotoPendukungError: false,
      activeFotoPendukungIndex: null,
      activeFotoPreviewIndex: null,
      minLengthFotoPendukung: 1,
      activeFotoPreview: "",

      optKendaraanJenis: [],
      optKendaraanMerk: [],
      optKendaraanTipe: [],
      optKendaraanTahun: [],
      optKendaraanKondisi: [],
      optKendaraanSpekJenis: {
        penambahan: [],
        pengurangan: [],
      },
      optKendaraanSpekMerk: {
        penambahan: [],
        pengurangan: [],
      },
      optKelengkapanKendaraan: [],
      optKendaraanWarna: [],

      optPromo: [],
      jenisIdentitas: [],
      requiredForDataKerabatAndPihakLain: false,
      cabangId: "",

      showDataLainnya: "false",

      boxSatu: "",
      boxDua: "",
      boxTiga: "",

      valUmur: true,

      kota: [],

      copyStnk: {
        kota: "",
        kecamatan: "",
        kelurahan: "",
        rt: "",
        rw: "",
        alamat: "",
      },

      disabled: false,

      seAnggota: null,
      seJenis: null,
      seMerk: null,
      seTipe: null,
      seKondisi: null,
      seKondisiDariMerk: null,
      showSeKondisi: false,
      seTahun: null,
      seKelengkapan: null,
      seWarnaKendaraan: null,
      seStatusKendaraan: null,
      seNoPolisi: null,

      pdfReadAnggota: true,
      pdfReadJenis: true,
      pdfReadMerk: true,
      pdfReadTipe: true,
      pdfReadKondisi: true,
      pdfReadTahun: true,
      pdfReadKelengkapan: true,
      pdfReadSpesifikasiJenis: true,
      pdfReadSpesifikasiMerk: true,
      pdfReadWarnaKendaraan: true,
      pdfReadStatusKendaraan: true,
      pdfReadNoPolisi: true,

      activeSE: null,

      fields: [{ key: "se", label: "Surat Edaran" }],
      isBusy: true,

      currentPage: 1,
      perPage: 1,
      rows: null,

      startTime: null,
      elapsedTime: 0,
      intervalId: null,

      wilayahList: [],
      wilayahListOriginal: [],
      isModalEditAnggota: false,
      stateMerkKendaraan: {
        isLoading: false,
        error: null,
      },
      stateTipeKendaraan: {
        isLoading: false,
        error: null,
      },
      stateTahunKendaraan: {
        isLoading: false,
        error: null,
      },
      stateGradeKendaraan: {
        isLoading: false,
        error: null,
      },
      stateKelengkapanKendaraan: {
        isLoading: false,
        error: null,
      },
      stateSpesifikasiJenisKendaraan: {
        isLoading: false,
        error: null,
      },
      stateSpesifikasiMerkKendaraan: {
        isLoading: false,
        error: null,
      },
      isLoadingHasTahun: false,
      isLoadingReqApproval: false,
      selectedRow: null,
      stateListAnggota: {
          isLoading: false,
          isError: false,
      }
    };
  },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.elapsedTime / 60000);
      const seconds = Math.floor((this.elapsedTime % 60000) / 1000);
      return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    },
    isRunning() {
      return this.intervalId !== null;
    },
    textCreatedNopol() {
        const filterWilayah = this.wilayahListOriginal.find(
            (item) => item.name === this.boxSatu
        );

        if (!filterWilayah || !filterWilayah.createdAt) {
            return '';
        }

        return `dibuat pada ${this.$helper.changeDateFormat(filterWilayah.createdAt)}`;
    },
    IS_HAVE_PERMISSION_REQUEST_EDIT() {
      const hasPermissionEdit = this.$helper.hasPermissionMenuChildren('EDN')
      return hasPermissionEdit;
    },
  },
  methods: {
    //----------------- Fungsi Inisialisasi -----------------

    init() {
      this.initStatus = 0;
      this.role = localStorage.getItem("role");
      this.editAnggota = localStorage.getItem("menuChildren").includes("EDA")
        ? true
        : false;

      let getJenisKendaraan = this.$axios
        .get("barang-jenis/kendaraan")
        .then((response) => {
          this.optKendaraanJenis = response.data;
        });

      let getWarnaKend = this.$axios.get("gadai/warna").then((response) => {
        this.optKendaraanWarna = response.data;
      });

      let seAnggota = this.$axios
        .get("surat-edaran/list/?menu=anggota&jenis=anggota")
        .then((response) => {
          if (response.data.length != 0) {
            this.seAnggota = response.data;
            for (var se of this.seAnggota) {
              if (se.isViewSE == "false") {
                this.pdfReadAnggota = false;
              }
            }
          }
        });

      let seWarnaKendaraan = this.$axios
        .get("surat-edaran/list/?menu=WarnaKendaraan&jenis=WarnaKendaraan")
        .then((response) => {
          if (response.data.length != 0) {
            this.seWarnaKendaraan = response.data;
            for (var se of this.seWarnaKendaraan) {
              if (se.isViewSE == "false") {
                this.pdfReadWarnaKendaraan = false;
              }
            }
          }
        });

      let seStatusKendaraan = this.$axios
        .get("surat-edaran/list/?menu=StatusKendaraan&jenis=StatusKendaraan")
        .then((response) => {
          if (response.data.length != 0) {
            this.seStatusKendaraan = response.data;
            for (var se of this.seStatusKendaraan) {
              if (se.isViewSE == "false") {
                this.pdfReadStatusKendaraan = false;
              }
            }
          }
        });

      let seNoPolisi = this.$axios
        .get("surat-edaran/list/?menu=NoPolisi&jenis=NoPolisi")
        .then((response) => {
          if (response.data.length != 0) {
            this.seNoPolisi = response.data;
            for (var se of this.seNoPolisi) {
              if (se.isViewSE == "false") {
                this.pdfReadNoPolisi = false;
              }
            }
          }
        });

      // Get data bila ada query referensi
      let ref = this.$route.query.ref;
      if (ref != null) {
        this.$axios.get("gadai-mobile/antrian/detail/" + ref).then((res) => {
          let data = res.data;
          this.selectAnggota(data.nasabah);
          this.input.jenisKendaraan = data.jenis;
          this.input.merkKendaraan = data.merk;
          this.input.tipeKendaraan = data.tipe;

          this.$axios
            .get("barang-tipe-v2/barang-tahun/" + data.tipe.id)
            .then((response) => {
              for (var x of response.data) {
                if (x.isActive == true) {
                  this.optKendaraanTahun.push({
                    id: x.id,
                    name: x.tahun,
                  });
                }
              }

              this.input.tahunKendaraan = data.tahun;
            });
          this.input.warnaKendaraan = data.warna.id;

          const kata = data.licensePlate.split(" ");

          this.boxSatu = kata.slice(0, 1).join(" "); // Mengambil kata pertama
          this.boxDua = kata.slice(1, kata.length - 1).join(" "); // Mengambil kata tengah
          this.boxTiga = kata.slice(kata.length - 1).join(" "); // Mengambil kata terakhir

          this.input.namaBpkb = data.atasNama;
        });
      }

      if (localStorage.getItem("gadaiFromSimulasi") != null) {
        if (localStorage.getItem("anggotaFromSimulasi") != null) {
          this.selectAnggota(JSON.parse(localStorage.getItem("anggotaFromSimulasi")));
          localStorage.removeItem("anggotaFromSimulasi");
        }

        let data = JSON.parse(localStorage.getItem("gadaiFromSimulasi"));

        this.input.jenisKendaraan = data.jenis;
        this.input.merkKendaraan = data.merk;
        this.input.tipeKendaraan = data.tipe;

        this.$axios
          .get("barang-tipe-v2/barang-tahun/" + data.tipe.id)
          .then((response) => {
            for (var x of response.data) {
              if (x.isActive == true) {
                this.optKendaraanTahun.push({
                  id: x.id,
                  name: x.tahun,
                });
              }
            }

            let idx = this.optKendaraanTahun.findIndex((item) => item.id == data.tahun);

            this.input.tahunKendaraan = this.optKendaraanTahun[idx];
          });

        this.$axios.get(`barang-tipe-v2/kondisi/${data.tipe.id}`).then((response) => {
          this.optKendaraanKondisi = [];
          let responseKondisi = response.data;
          responseKondisi = responseKondisi.filter((item) => item.isActive == true);
          for (let y = 0; y < responseKondisi.length; y++) {
            let dataKondisi = {};
            dataKondisi.value = responseKondisi[y].id;
            dataKondisi.text = responseKondisi[y].name.substring(4);
            this.optKendaraanKondisi.push(dataKondisi);
          }

          let idx = this.optKendaraanKondisi.findIndex(
            (item) => item.value == data.kondisi
          );
          this.input.kondisiKendaraan = this.optKendaraanKondisi[idx];
        });

        this.input.spesifikasiKendaraanMerk = data.spesifikasiMerk;
        this.input.kondisiKendaraan = data.kendaraanKondisi;
        this.input.spesifikasiKendaraanJenis = data.spek;
        this.input.dataStnk.masaBerlakuStnk = data.tanggalPajak || "";
        if (data.tanggalPajak) {
          this.isFromSimulasi = true;
        }
        localStorage.removeItem("gadaiFromSimulasi");
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.lat = position.coords.latitude;
          this.long = position.coords.longitude;
        },
        (error) => {
        }
      );

      Promise.all([
        getJenisKendaraan,
        getWarnaKend,
        seAnggota,
        seWarnaKendaraan,
        seStatusKendaraan,
        seNoPolisi,
      ])
        .then(() => {
          this.initStatus = 1;
        })
        .catch((error) => {
          this.initStatus = -1;
        });

      this.cabangId = this.$helper.getCabangId();
    },

    reset() {
      this.$bvModal.hide("modal-sukses");
      this.$bvModal.hide("modal-konfirmasi");
      this.$bvModal.hide("modal-rincian");

      if (this.$route.query.ref != null) {
        this.$router.replace("/gadai/kendaraan");
      }

      this.anggota.id = null;
      this.anggota.nama = "-";
      this.anggota.no = "-";
      this.anggota.noMember = "-";
      this.anggota.jenisIdentitas = "-";
      this.anggota.noIdentitas = "-";
      this.anggota.noHp = "-";
      this.anggota.noRumah = "-";
      this.anggota.alamat = "-";
      this.anggota.statusPembayaran = null;
      this.anggota.identitas = [];

      this.input.isBpkb = true;
      this.input.jenisKendaraan = { id: null, name: null };
      this.input.merkKendaraan = { id: null, name: null };
      this.input.tipeKendaraan = null;
      this.input.tahunKendaraan = null;
      this.input.kondisiKendaraan = null;
      this.input.warnaKendaraan = null;
      this.input.kelengkapanKendaraan = [];
      this.input.spesifikasiKendaraanJenis = [];
      this.input.spesifikasiKendaraanMerk = [];
      this.input.statusKendaraan = "";
      this.input.noPolisi = "";

      this.input.dataStnk.namaStnk = "";
      this.input.dataStnk.kotaStnk = "";
      this.input.dataStnk.kotaStnkId = "";
      this.input.dataStnk.kecamatanStnk = null;
      this.input.dataStnk.kelurahanDesaStnk = null;
      this.input.dataStnk.alamatStnk = "";
      this.input.dataStnk.masaBerlakuStnk = "";
      this.input.dataStnk.rtStnk = "";
      this.input.dataStnk.rwStnk = "";
      this.input.dataStnk.copy = false;

      this.input.noBpkb = "";
      this.input.namaBpkb = "";
      this.input.noMesin = "";
      this.input.noRangka = "";
      (this.input.fotoPendukung = [
        {
          index: 0,
          id: 0,
          name: "Foto KTP",
          checkFotoBarangPendukung: false,
          fotoBarangPendukungPlaceholder: "Choose a file",
          fotoBarangPendukung: null,
          fotoBarangPendukungBase64: null,
          activeFotoPendukungBase64: null,
          require: true,
        },
        {
          index: 1,
          id: 0,
          name: "SS verifikasi WA (Terlihat no WA nasabah)",
          checkFotoBarangPendukung: false,
          fotoBarangPendukungPlaceholder: "Choose a file",
          fotoBarangPendukung: null,
          fotoBarangPendukungBase64: null,
          activeFotoPendukungBase64: null,
          require: true,
        },
        {
          index: 2,
          id: 0,
          name: "Foto BPKB halaman Identitas Pemilik",
          checkFotoBarangPendukung: false,
          fotoBarangPendukungPlaceholder: "Choose a file",
          fotoBarangPendukung: null,
          fotoBarangPendukungBase64: null,
          activeFotoPendukungBase64: null,
          require: true,
        },
        {
          index: 3,
          id: 0,
          name: " Foto BPKB halaman Identitas Motor",
          checkFotoBarangPendukung: false,
          fotoBarangPendukungPlaceholder: "Choose a file",
          fotoBarangPendukung: null,
          fotoBarangPendukungBase64: null,
          activeFotoPendukungBase64: null,
          require: true,
        },
        {
          index: 4,
          id: 0,
          name: "Foto BPKB halaman Identitas Perubahan (opsional)",
          checkFotoBarangPendukung: false,
          fotoBarangPendukungPlaceholder: "Choose a file",
          fotoBarangPendukung: null,
          fotoBarangPendukungBase64: null,
          activeFotoPendukungBase64: null,
          require: false,
        },
        {
          index: 5,
          id: 0,
          name: "Foto STNK tampak depan (pajak tahunan)",
          checkFotoBarangPendukung: false,
          fotoBarangPendukungPlaceholder: "Choose a file",
          fotoBarangPendukung: null,
          fotoBarangPendukungBase64: null,
          activeFotoPendukungBase64: null,
          require: true,
        },
        {
          index: 6,
          id: 0,
          name: "Foto STNK tampak belakang (pajak 5 tahun) (opsional)",
          checkFotoBarangPendukung: false,
          fotoBarangPendukungPlaceholder: "Choose a file",
          fotoBarangPendukung: null,
          fotoBarangPendukungBase64: null,
          activeFotoPendukungBase64: null,
          require: false,
        },
        {
          index: 7,
          id: 0,
          name: "Nasabah + Motor",
          checkFotoBarangPendukung: false,
          fotoBarangPendukungPlaceholder: "Choose a file",
          fotoBarangPendukung: null,
          fotoBarangPendukungBase64: null,
          activeFotoPendukungBase64: null,
          require: true,
        },
        {
          index: 8,
          id: 0,
          name: "Surat Pernyataan",
          checkFotoBarangPendukung: false,
          fotoBarangPendukungPlaceholder: "Choose a file",
          fotoBarangPendukung: null,
          fotoBarangPendukungBase64: null,
          activeFotoPendukungBase64: null,
          require: true,
        },
        {
          index: 9,
          id: 0,
          name: "Foto Kartu Keluarga",
          checkFotoBarangPendukung: false,
          fotoBarangPendukungPlaceholder: "Choose a file",
          fotoBarangPendukung: null,
          fotoBarangPendukungBase64: null,
          activeFotoPendukungBase64: null,
          require: false,
        },
      ]),
        (this.input.useVoucher = false);
      this.input.voucherCode = "";
      this.input.disburseType = 0;
      (this.boxSatu = ""), (this.boxDua = ""), (this.boxTiga = "");

      this.valUmur = true;

      window.scroll(0, 0);
    },

    boxNoPolisiSatu(event) {
      let boxSatu = event.target.value.toUpperCase();
      this.boxSatu = boxSatu;
      this.input.noPolisi = this.boxSatu + " " + this.boxDua + " " + this.boxTiga;
    },

    boxNoPolisiDua(event) {
      let boxDua = event.target.value.toUpperCase();
      this.boxDua = boxDua;
      this.input.noPolisi = this.boxSatu + " " + this.boxDua + " " + this.boxTiga;
    },

    boxNoPolisiTiga(event) {
      let boxTiga = event.target.value.toUpperCase();
      this.boxTiga = boxTiga;
      this.input.noPolisi = this.boxSatu + " " + this.boxDua + " " + this.boxTiga;
    },

    addAnggota() {
      this.isModalEditAnggota = false;
      this.$bvModal.show("modal-input-anggota");
    },

    showEditAnggota() {
      this.isModalEditAnggota = true;
      this.$bvModal.show('modal-edit-anggota')
    },

    showEditIdentitas() {
      this.isModalEditAnggota = false;
      this.$bvModal.show('modal-identitas-list-c')
    },

    openSearchAnggotaModal() {
      this.$bvModal.show("modal-pilih-anggota");
    },

    selectAnggota(item) {
      this.anggota.id = item.id;
      this.anggota.nama = item.nama;
      this.anggota.no = item.no;
      this.anggota.noMember = item.noMember;
      // this.anggota.jenisIdentitas = item.jenisIdentitas.name
      // this.anggota.noIdentitas = item.noIdentitas
      if (item.identitas && item.identitas.length > 0) {
        this.anggota.jenisIdentitas = item.identitas[0].jenisIdentitas
        this.anggota.noIdentitas = item.identitas[0].noIdentitas
      }
      this.anggota.noHp = item.noHp;
      this.anggota.noRumah = item.noRumah;
      this.anggota.alamat = item.alamat;
      this.anggota.isComplete = item.isComplete;
      this.anggota.shouldUpdate = item.shouldUpdateData;
      this.anggota.shouldUpdatePhone = item.shouldUpdatePhone;
      this.anggota.statusPembayaran = item.statusPembayaran;
      this.anggota.identitas = item.identitas;

      this.anggota.fotoKtp = item.detail.fotoKtp;

      // calculate umur
      this.anggota.tanggalLahir = item.tanggalLahir;

      this.valUmur = this.$helper.validasiUmurNasabah(this.anggota.tanggalLahir);
      if (item.shouldUpdatePhone == true) {
        this.$bvModal.show("modal-update-telepon");
      }
      if (this.valUmur == false) {
        return this.$helper.toastErr(
          this,
          "Maaf umur nasabah belum 18 tahun, tidak bisa melakukan gadai."
        );
      }

      this.$bvModal.hide("modal-pilih-anggota");
      // Jika is complete false get data kosong
      if (item.isComplete == false) {
        this.$axios.get(`nasabah/${item.id}`).then((response) => {
          this.dataKosong.namaAyah = response.data.detail.namaAyah;
          this.dataKosong.noHandphoneAyah = response.data.detail.noHandphoneAyah;
          this.dataKosong.namaIbu = response.data.detail.namaIbu;
          this.dataKosong.noHandphoneIbu = response.data.detail.noHandphoneIbu;
          this.dataKosong.namaPihakLain = response.data.detail.namaPihakLain;
          this.dataKosong.hubunganPihakLain = response.data.detail.hubunganPihakLain;
          this.dataKosong.noHandphonePihakLain =
            response.data.detail.noHandphonePihakLain;
          this.dataKosong.kotaPihakLain = response.data.detail.kotaPihakLain.id;
          this.dataKosong.kecamatanPihakLain = response.data.detail.kecamatanPihakLain.id;
          this.dataKosong.kelurahanDesaPihakLain =
            response.data.detail.kecamatanPihakLain.id;
          this.dataKosong.rtPihakLain = response.data.detail.rtPihakLain;
          this.dataKosong.rwPihakLain = response.data.detail.rwPihakLain;
          this.dataKosong.alamatPihakLain = response.data.detail.alamatPihakLain;
          this.dataKosong.nomorGang =
            this.$helper.isNullOrEmpty(response.data.detail.nomorGang) && null;
          this.dataKosong.nomorRumah =
            this.$helper.isNullOrEmpty(response.data.detail.nomorRumah) && null;
          this.dataKosong.fotoFormDataBpkb =
            this.$helper.isNullOrEmpty(response.data.detail.fotoFormDataBpkb) && null;
        });
      }
      this.checkNasabah();

      this.copyStnk.alamat = item.detail.alamatKtp;
      this.copyStnk.kota = item.detail.kotaKtp;
      this.copyStnk.kecamatan = item.detail.kecamatanKtp.id;
      this.copyStnk.kelurahan = item.detail.kelurahanDesaKtp.id;
      this.copyStnk.rt = item.detail.rtKtp;
      this.copyStnk.rw = item.detail.rwKtp;

      if (this.anggota.shouldUpdate == true) {
        this.$bvModal.show("modal-info-update");
      }
    },

    showModalEditAnggota() {
      this.$bvModal.show("modal-edit-anggota");
      this.$bvModal.hide("modal-info-update");
    },

    checkPromo() {
      if (
        this.input.jenisKendaraan !== null &&
        this.input.merkKendaraan !== null &&
        this.input.tipeKendaraan !== null &&
        this.input.tahunKendaraan != null
      ) {
        let path =
          "gadai-crud/promo?jenisPinjamanId=2&jenisKendaraanId=" +
          this.input.jenisKendaraan.id +
          "&merkId=" +
          this.input.merkKendaraan.id +
          "&tipeId=" +
          this.input.tipeKendaraan.id +
          "&tahunId=" +
          this.input.tahunKendaraan.id +
          "&isBpkb=" +
          this.input.isBpkb +
          "&cabangId=" +
          this.cabangId;

        this.input.promo = [];

        this.isGettingPromo = true;
        this.$axios
          .get(path)
          .then((response) => {
            this.optPromo = response.data;
            this.isPromoRetrieved = true;
          })
          .catch((error) => {
            this.$helper.parseError(this, error);
          })
          .finally(() => {
            this.isGettingPromo = false;
          });
      } else {
        this.$helper.toastErr(
          this,
          "Mohon lengkapi jenis, merk, tipe, dan tahun barang terlebih dahulu"
        );
      }
    },

    calculateMaksimumPinjaman() {
      // Check all data has been filled
      if (this.anggota.id == null) {
        this.$helper.toastErr(this, "Mohon memilih anggota terlebih dahulu!");
        return;
      }

      if (this.anggota.shouldUpdatePhone == true) {
        this.$helper.toastErr(this, "Mohon update no telepon anggota terlebih dahulu!");
        return;
      }

      if (
        this.input.jenisKendaraan == null ||
        this.input.merkKendaraan == null ||
        this.input.warnaKendaraan == null ||
        this.input.tipeKendaraan == null ||
        this.input.tahunKendaraan == null ||
        this.input.kondisiKendaraan == null ||
        this.input.statusKendaraan == ""
      ) {
        this.$helper.toastErr(this, "Mohon lengkapi data gadai terlebih dahulu!");
        return;
      }

      // Check if there is at least one picture attached
      if (
        this.input.fotoPendukung.length == 1 &&
        this.$helper.isNullOrEmpty(this.input.fotoPendukung[0].activeFotoPendukungBase64)
      ) {
        this.$helper.toastErr(this, "Mohon upload minimal 1 gambar!");
        return;
      }
      if (this.input.dataStnk.submitMasaBerlakuStnk == false) {
        this.$helper.toastErr(
          this,
          "Maaf Masa berlaku STNK lebih dari 6 bulan, tidak bisa melakukan gadai."
        );
        return;
      }

      // Check if all photo row has been filled
      for (var i = 0; i < this.input.fotoPendukung.length; i++) {
        let item = this.input.fotoPendukung[i];
        if (item.require == true) {
          if (this.$helper.isNullOrEmpty(item.activeFotoPendukungBase64)) {
            this.$helper.toastErr(this, item.name + " Perlu di upload");
            return;
          }
        } else {
        }
      }

      // Bila umur belum 18 tahun
      if (this.valUmur == false) {
        return this.$helper.toastErr(
          this,
          "Maaf umur nasabah belum 18 tahun, tidak bisa melakukan gadai."
        );
      }

      const resultValidatePajak = this.$helper.validateBatasMasaPajak(this.input.dataStnk.masaBerlakuStnk);
      if (!resultValidatePajak.valid) {
        this.$helper.toastErr(this, resultValidatePajak.message);
        return;
      }

      let payload = this.preparePayload();

      this.isSubmitting = true;
      this.$axios
        .post("gadai-crud/gadai/kendaraan", payload)
        .then((response) => {
          if (response.data.noFaktur == "REFRESH_KONDISI") {
            this.$helper.toastErr(
              this,
              "Harga barang baru saja diperbarui HO. Silahkan isi ulang Kondisi / Grade Barang!"
            );
            this.input.kondisiKendaraan = null;
            this.optKendaraanKondisi = [];
            this.$axios
              .get(`barang-tipe-v2/kondisi/${this.input.tipeKendaraan.id}`)
              .then((response) => {
                let responseKondisi = response.data;
                for (let y = 0; y < responseKondisi.length; y++) {
                  let dataKondisi = {};
                  dataKondisi.value = responseKondisi[y].id;
                  dataKondisi.text = responseKondisi[y].name.substring(4);
                  this.optKendaraanKondisi.push(dataKondisi);
                }
              });
          } else {
            let data = response.data;
            this.rincian = data;

            if (response.data.noFakturSuspectGanda != null) {
              this.rincian.showAlertNoFakturGanda = true;
              this.rincian.alertNoPol = this.input.noPolisi;
              this.rincian.alertNoMesin = this.input.noMesin;
              this.rincian.alertGadai = "kend";
              this.rincian.alertNoFakturGanda = response.data.noFakturSuspectGanda;
            }

            // Arrange nama lengkap barang
            this.namaLengkapBarang = `${this.input.jenisKendaraan.name} - ${this.input.merkKendaraan.name} - ${this.input.tipeKendaraan.name}`;
            if (this.input.tahunKendaraan != null) {
              this.namaLengkapBarang += ` - ${this.input.tahunKendaraan.name}`;
            }

            this.$bvModal.show("modal-rincian");
          }
        })
        .catch((error) => {
          this.$helper.parseError(this, error);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },

    calculateConfirmation(data) {
      if (data.nilaiPinjaman % 50000 != 0) {
        this.$helper.toastErr(this, "Pinjaman hanya boleh dalam kelipatan Rp 50.000");
      } else {
        let payload = this.preparePayload(data);

        this.isSubmitting = true;
        this.$axios
          .post("gadai-crud/gadai/kendaraan", payload)
          .then((response) => {
            if (response.data.noFaktur == "REFRESH_KONDISI") {
              this.$helper.toastErr(
                this,
                "Harga barang baru saja diperbarui HO. Silahkan isi ulang Kondisi / Grade Barang!"
              );
              this.input.kondisiKendaraan = null;
              this.optKendaraanKondisi = [];
              this.$axios
                .get(`barang-tipe-v2/kondisi/${this.input.tipeKendaraan.id}`)
                .then((response) => {
                  let responseKondisi = response.data;
                  for (let y = 0; y < responseKondisi.length; y++) {
                    let dataKondisi = {};
                    dataKondisi.value = responseKondisi[y].id;
                    dataKondisi.text = responseKondisi[y].name.substring(4);
                    this.optKendaraanKondisi.push(dataKondisi);
                  }
                });
              this.$bvModal.hide("modal-rincian");
            } else {
              let data = response.data;
              this.rincian = data;

              this.$bvModal.show("modal-konfirmasi");
            }
          })
          .catch((error) => {
            if (
              error.response.data.reason.includes(
                "Beneficiary email must be a valid email address"
              )
            ) {
              this.$helper.toastErr(
                this,
                "nasabah tidak memiliki email , mohon isi email terlebih dahulu"
              );
            } else {
              this.$helper.parseError(this, error);
            }
          })
          .finally(() => {
            this.isSubmitting = false;
          });
      }
    },

    submitGadai() {
      let data = {
        nilaiPinjaman: this.input.nilaiPinjaman,
        useVoucher: this.input.useVoucher,
        voucherCode: this.input.voucherCode,
        disburseType: this.input.disburseType,
      };

      let payload = this.preparePayload(data, true);

      this.isSubmitting = true;
      this.$axios
        .post("gadai-crud/gadai/kendaraan", payload, { timeout: 300000 })
        .then((response) => {
          if (response.data.noFaktur == "REFRESH_KONDISI") {
            this.$helper.toastErr(
              this,
              "Harga barang baru saja diperbarui HO. Silahkan isi ulang Kondisi / Grade Barang!"
            );
            this.input.kondisiKendaraan = null;
            this.optKendaraanKondisi = [];
            this.$axios
              .get(`barang-tipe-v2/kondisi/${this.input.tipeKendaraan.id}`)
              .then((response) => {
                let responseKondisi = response.data;
                for (let y = 0; y < responseKondisi.length; y++) {
                  let dataKondisi = {};
                  dataKondisi.value = responseKondisi[y].id;
                  dataKondisi.text = responseKondisi[y].name.substring(4);
                  this.optKendaraanKondisi.push(dataKondisi);
                }
              });
            this.$bvModal.hide("modal-konfirmasi");
            this.$bvModal.hide("modal-rincian");
          } else {
            this.input.jenisKendaraan = { id: null, name: null };
            this.input.merkKendaraan = { id: null, name: null };
            this.input.tipeKendaraan = null;

            let data = response.data;
            this.rincian.noFaktur = data.noFaktur;
            this.$bvModal.show("modal-sukses");
          }
        })
        .catch((error) => {
          if (
            error.response.data.reason.includes(
              "Beneficiary email must be a valid email address"
            )
          ) {
            this.$helper.toastErr(
              this,
              "nasabah tidak memiliki email , mohon isi email terlebih dahulu"
            );
          } else {
            this.$helper.parseError(this, error);
          }
        })
        .finally(() => {
          this.resetTime();
          this.isSubmitting = false;
        });
    },

    preparePayload(data = null, finalizePayment = false) {
      let payload = new FormData();
      payload.append("nasabahId", this.anggota.id);
      payload.append("jenisPinjamanId", 2); // MARK HARDCODE
      payload.append("jenisBarangId", this.input.jenisKendaraan.id);
      payload.append("merkId", this.input.merkKendaraan.id);
      payload.append("tipeId", this.input.tipeKendaraan.id);
      payload.append("kondisiId", this.input.kondisiKendaraan.value);
      payload.append("cabangId", localStorage.getItem("activeCabangId"));
      payload.append("finalizePayment", finalizePayment);
      payload.append("warnaId", this.input.warnaKendaraan);
      payload.append("isBpkb", this.input.isBpkb);
      payload.append("statusKendaraan", this.input.statusKendaraan);

      payload.append("stnkAtasNama", this.input.dataStnk.namaStnk);
      payload.append("kotaStnk", this.input.dataStnk.kotaStnkId);
      payload.append("kecamatanStnk", this.input.dataStnk.kecamatanStnk);
      payload.append("kelurahanStnk", this.input.dataStnk.kelurahanDesaStnk);
      payload.append("rtStnk", this.input.dataStnk.rtStnk);
      payload.append("rwStnk", this.input.dataStnk.rwStnk);
      payload.append("stnkAlamat", this.input.dataStnk.alamatStnk);
      payload.append("stnkMasaBerlakuPajak", this.input.dataStnk.masaBerlakuStnk);

      payload.append("noBpkb", this.input.noBpkb);
      payload.append("bpkbAtasNama", this.input.namaBpkb);
      payload.append("noMesin", this.input.noMesin);
      payload.append("noRangka", this.input.noRangka);
      payload.append("noPolisi", this.input.noPolisi);

      if (this.input.nominalHargaLainnya != null)
        payload.append("hargaBarangLainnya", this.input.nominalHargaLainnya);
      if (this.input.nominalAdminFeeLainnya != null)
        payload.append("adminFeeLainnya", this.input.nominalAdminFeeLainnya);

      // Append all checked spesifikasi
      for (let spek of this.input.spesifikasiKendaraanJenis) {
        payload.append("spesifikasiId", spek);
      }

      for (let spek of this.input.spesifikasiKendaraanMerk) {
        payload.append("spesifikasiId", spek);
      }

      // Append promo, if any is selected
      this.input.promo.forEach((promoId) => {
        payload.append("promoIds", promoId);
      });

      // Kelengkapan
      if (this.input.kelengkapanKendaraan.length != 0) {
        this.input.kelengkapanKendaraan.forEach((item) => {
          payload.append("kelengkapan", item.name);
        });
      }

      // Append tahun, if selected
      if (this.$helper.isNotNullAndNotEmpty(this.input.tahunKendaraan)) {
        payload.append("tahunId", this.input.tahunKendaraan.id);
      }

      // Append peminjaman dan voucher code, if data is not null
      if (data != null) {
        this.input.nilaiPinjaman = data.nilaiPinjaman;
        this.input.voucherCode = data.voucherCode;
        this.input.useVoucher = data.useVoucher;
        this.input.disburseType = data.disburseType;

        payload.append("jumlahPinjaman", data.nilaiPinjaman);
        payload.append("disburseType", data.disburseType);
        if (data.useVoucher == true) {
          payload.append("voucherCode", data.voucherCode);
        }
      }

      // Upload photo and no referensi only if on final step
      if (finalizePayment) {
        let jsonFoto = [];
        this.input.fotoPendukung.forEach(function (entry) {
          if (entry.activeFotoPendukungBase64 != null) {
            jsonFoto.push(entry.activeFotoPendukungBase64);
          }
        });

        payload.append("foto", JSON.stringify(jsonFoto));

        if (this.$route.query.ref != null) {
          payload.append("noRefAntrian", this.$route.query.ref);
        }
      }

      this.$helper.printPayload(payload);

      return payload;
    },

    inputNewAnggota(dataAnggota) {
      this.$bvModal.hide("modal-confirm-input");
      this.$bvModal.hide("modal-input-anggota");
      this.$helper.toastSucc(this, "Anggota nasabah baru telah berhasil dibuat!");
      
      this.$axios.get(`nasabah/${dataAnggota.idAnggota}`).then((response) => {
        this.dataKosong.namaAyah = response.data.detail.namaAyah;
        this.dataKosong.noHandphoneAyah = response.data.detail.noHandphoneAyah;
        this.dataKosong.namaIbu = response.data.detail.namaIbu;
        this.dataKosong.noHandphoneIbu = response.data.detail.noHandphoneIbu;
        this.dataKosong.namaPihakLain = response.data.detail.namaPihakLain;
        this.dataKosong.hubunganPihakLain = response.data.detail.hubunganPihakLain;
        this.dataKosong.noHandphonePihakLain = response.data.detail.noHandphonePihakLain;
        this.dataKosong.kotaPihakLain = response.data.detail.kotaPihakLain.id;
        this.dataKosong.kecamatanPihakLain = response.data.detail.kecamatanPihakLain.id;
        this.dataKosong.kelurahanDesaPihakLain =
          response.data.detail.kecamatanPihakLain.id;
        this.dataKosong.rtPihakLain = response.data.detail.rtPihakLain;
        this.dataKosong.rwPihakLain = response.data.detail.rwPihakLain;
        this.dataKosong.alamatPihakLain = response.data.detail.alamatPihakLain;
        this.dataKosong.nomorGang =
          this.$helper.isNullOrEmpty(response.data.detail.nomorGang) && null;
        this.dataKosong.nomorRumah =
          this.$helper.isNullOrEmpty(response.data.detail.nomorRumah) && null;
        this.dataKosong.fotoFormDataBpkb =
          this.$helper.isNullOrEmpty(response.data.detail.fotoFormDataBpkb) && null;
      });
    },

    editNewAnggota(dataAnggota) {
      //hide modal confirm dan modal anggota

      this.$bvModal.hide("modal-confirm-edit");
      this.$bvModal.hide("modal-edit-anggota");

      this.anggota.id = dataAnggota.idAnggota;
      this.anggota.nama = dataAnggota.nama;
      this.anggota.no = dataAnggota.noAnggota;
      this.anggota.noIdentitas = dataAnggota.noIdentitas;
      this.anggota.noHp = dataAnggota.noHp;
      this.anggota.noRumah = dataAnggota.noRumah;
      this.anggota.alamat = dataAnggota.alamat;
      this.anggota.isComplete = dataAnggota.isComplete;
      this.anggota.shouldUpdatePhone = dataAnggota.shouldUpdatePhone;
      this.anggota.identitas = dataAnggota.identitas;

      this.$axios.get(`nasabah/${this.anggota.id}`).then((response) => {
        this.dataKosong.namaAyah = response.data.detail.namaAyah;
        this.dataKosong.noHandphoneAyah = response.data.detail.noHandphoneAyah;
        this.dataKosong.namaIbu = response.data.detail.namaIbu;
        this.dataKosong.noHandphoneIbu = response.data.detail.noHandphoneIbu;
        this.dataKosong.namaPihakLain = response.data.detail.namaPihakLain;
        this.dataKosong.hubunganPihakLain = response.data.detail.hubunganPihakLain;
        this.dataKosong.noHandphonePihakLain = response.data.detail.noHandphonePihakLain;
        this.dataKosong.kotaPihakLain = response.data.detail.kotaPihakLain.id;
        this.dataKosong.kecamatanPihakLain = response.data.detail.kecamatanPihakLain.id;
        this.dataKosong.kelurahanDesaPihakLain =
          response.data.detail.kecamatanPihakLain.id;
        this.dataKosong.rtPihakLain = response.data.detail.rtPihakLain;
        this.dataKosong.rwPihakLain = response.data.detail.rwPihakLain;
        this.dataKosong.alamatPihakLain = response.data.detail.alamatPihakLain;
        this.dataKosong.nomorGang =
          this.$helper.isNullOrEmpty(response.data.detail.nomorGang) && null;
        this.dataKosong.nomorRumah =
          this.$helper.isNullOrEmpty(response.data.detail.nomorRumah) && null;
        this.dataKosong.fotoFormDataBpkb =
          this.$helper.isNullOrEmpty(response.data.detail.fotoFormDataBpkb) && null;
      });

      this.checkNasabah();
    },

    checkTipePinjaman() {
      this.input.isBpkb = !this.input.isBpkb;
      this.checkNasabah();
    },

    checkNasabah() {
      if (this.input.isBpkb && this.anggota.id !== null) {
        if (!this.anggota.isComplete) {
          this.showAlertEditAnggota = true;
        } else if (this.anggota.shouldUpdatePhone) {
          this.showAlertEditAnggota = true;
        } else {
          this.showAlertEditAnggota = false;
        }
      } else {
        this.showAlertEditAnggota = false;
      }
    },

    confirmUpgradeMember() {
      this.$bvModal.show("modal-confirm-upgrade");
    },

    execUpgradeMember() {
      let payload = new FormData();
      payload.append("nasabahId", this.anggota.id);
      payload.append("cabangId", localStorage.getItem("activeCabangId"));

      this.isSubmitting = true;
      this.$axios
        .post("nasabah/upgrade-member", payload)
        .then((res) => {
          this.anggota.noMember = res.data.name;
          this.$bvModal.hide("modal-upgrade-member");
          this.$bvModal.hide("modal-confirm-upgrade");
          this.$helper.toastSucc(this, "Anggota berhasil diupgrade menjadi member!");
        })
        .catch((error) => this.$helper.parseError(this, error))
        .finally(() => (this.isSubmitting = false));
    },

    openModalCam(index) {
      this.activeFotoPendukungIndex = index;
      this.$bvModal.show("webcam-input-kend");
    },

    openModalPreview(index) {
      this.activeFotoPreviewIndex = index;
      let idx = this.input.fotoPendukung.findIndex(
        (item) => item.index == this.activeFotoPreviewIndex
      );
      this.activeFotoPreview = this.input.fotoPendukung[idx].fotoBarangPendukungBase64;
      this.$bvModal.show("modal-preview-gadai");
    },

    async setResult(result) {
      let formattedDate = this.$helper.formatTanggalDMY();
      let waktu = this.$helper.waktu24();

      //resize image
      var newResult = await this.$helper.resizeImage(result);

      //add timestamp & location
      let img = new Image();
      img.src = newResult;
      img.onload = () => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        canvas.setAttribute("width", img.width);
        canvas.setAttribute("height", img.height);
        ctx.drawImage(img, 0, 0);
        ctx.font = "14pt Arial";
        ctx.fillStyle = "#ffffff"; //<======= here
        ctx.fillText(formattedDate + " " + waktu, 10, img.height - 40);
        ctx.strokeText(formattedDate + " " + waktu, 10, img.height - 40);
        ctx.fillText(this.lat + " " + this.long, 10, img.height - 10);
        ctx.strokeText(this.lat + " " + this.long, 10, img.height - 10);
        let newBase64Str = canvas.toDataURL("image/jpeg", 0.9);

        let idx = this.input.fotoPendukung.findIndex(
          (item) => item.index == this.activeFotoPendukungIndex
        );
        this.input.fotoPendukung[idx].fotoBarangPendukungBase64 = newBase64Str;
        this.input.fotoPendukung[idx].activeFotoPendukungBase64 = newBase64Str;
        this.input.fotoPendukung[idx].fotoBarangPendukungPlaceholder = "Foto dari Kamera";
        this.input.fotoPendukung[idx].checkFotoBarangPendukung = true;
      };
    },

    //----------------- Fungsi Tambah Hapus Data Foto Pendukung -----------------

    addFotoPendukung() {
      if (this.indexFotoPendukung < 6) {
        this.input.fotoPendukung.unshift({
          index: this.indexFotoPendukung,
          id: 0,
          index: this.indexFotoPendukung,
          checkFotoBarangPendukung: false,
          fotoBarangPendukungPlaceholder: "Choose a file",
          fotoBarangPendukung: null,
          fotoBarangPendukungBase64: null,
          activeFotoPendukungBase64: null,
        });
        this.indexFotoPendukung++;
      } else {
        this.fotoPendukungError = true;
      }
    },

    removeFotoPendukung(index) {
      this.input.fotoPendukung = this.input.fotoPendukung.filter(
        (item) => item.index != index
      );
      this.fotoPendukungError = false;
    },

    openModalSE(se, jenis, isViewSE, kondisiSpek, idSpek) {
      this.activeSE = se;
      this.rows = se.length;

      if (isViewSE == false) {
        let payload = new FormData();

        let id = 0;
        if (jenis == "jenis") {
          id = this.input.jenisKendaraan.id;
          payload.append("id", jenis + id);
        }
        if (jenis == "merk") {
          id = this.input.merkKendaraan.id;
          payload.append("id", jenis + id);
        }
        if (jenis == "tipe") {
          id = this.input.tipeKendaraan.id;
          payload.append("id", jenis + id);
        }
        if (jenis == "kondisi") {
          payload.append("id", this.seKondisi[0].barang);
        }
        if (jenis == "tahun") {
          id = this.input.tipeKendaraan.id;
          payload.append("id", jenis + id);
        }
        if (jenis == "kelengkapan") {
          id = this.input.jenisKendaraan.id;
          payload.append("id", jenis + id);
        }
        if (jenis == "spesifikasiJenis") {
          id = idSpek;
          payload.append("id", "spesifikasi" + id);
        }
        if (jenis == "spesifikasiMerk") {
          id = idSpek;
          payload.append("id", "spesifikasi" + id);
        }
        if (jenis == "anggota") {
          payload.append("id", "anggota");
        }
        if (jenis == "WarnaKendaraan") {
          payload.append("id", "WarnaKendaraan");
        }
        if (jenis == "StatusKendaraan") {
          payload.append("id", "StatusKendaraan");
        }
        if (jenis == "NoPolisi") {
          payload.append("id", "NoPolisi");
        }
        this.$axios.post(`surat-edaran/view`, payload).then((response) => {
          if (jenis == "anggota") {
            this.pdfReadAnggota = true;
          }
          if (jenis == "jenis") {
            this.pdfReadJenis = true;
          }
          if (jenis == "merk") {
            this.pdfReadMerk = true;
          }
          if (jenis == "tipe") {
            this.pdfReadTipe = true;
          }
          if (jenis == "tahun") {
            this.pdfReadTahun = true;
          }
          if (jenis == "kondisi") {
            this.pdfReadKondisi = true;
          }
          if (jenis == "kelengkapan") {
            this.pdfReadKelengkapan = true;
          }
          if (jenis == "spesifikasiJenis") {
            if (kondisiSpek == "penambahanSpekJenis") {
              let idx = this.optKendaraanSpekJenis.penambahan.findIndex(
                (item) => item.id == idSpek
              );
              this.optKendaraanSpekJenis.penambahan[idx].isViewSE = true;
            }
            if (kondisiSpek == "penguranganSpekJenis") {
              let idx = this.optKendaraanSpekJenis.pengurangan.findIndex(
                (item) => item.id == idSpek
              );
              this.optKendaraanSpekJenis.pengurangan[idx].isViewSE = true;
            }
          }
          if (jenis == "spesifikasiMerk") {
            if (kondisiSpek == "penambahanSpekMerk") {
              let idx = this.optKendaraanSpekMerk.penambahan.findIndex(
                (item) => item.id == idSpek
              );
              this.optKendaraanSpekMerk.penambahan[idx].isViewSE = true;
            }
            if (kondisiSpek == "penguranganSpekMerk") {
              let idx = this.optKendaraanSpekMerk.pengurangan.findIndex(
                (item) => item.id == idSpek
              );
              this.optKendaraanSpekMerk.pengurangan[idx].isViewSE = true;
            }
          }
          if (jenis == "WarnaKendaraan") {
            this.pdfReadWarnaKendaraan = true;
          }
          if (jenis == "StatusKendaraan") {
            this.pdfReadStatusKendaraan = true;
          }
          if (jenis == "NoPolisi") {
            this.pdfReadNoPolisi = true;
          }
        });
        this.$bvModal.show("modal-SE-load");
      } else {
        this.$bvModal.show("modal-SE");
      }
    },

    onPageChange() {
      this.interval = true;

      this.intervalId = null;
      this.progress = 0;
      this.intervalId = setInterval(() => {
        this.progress += 10;
        if (this.progress >= 100) {
          clearInterval(this.intervalId);
        }
      }, 500);

      setTimeout(this.page, 5000);
    },

    page() {
      this.interval = false;
      let prevLimit = null;
      let limit = null;
      prevLimit = (this.currentPage - 1) * 1 + 1;
      limit = (this.currentPage - 1) * 1 + 1;
      if (limit > this.rows) limit = this.rows;
      this.totalViewText =
        "Menampilkan " + prevLimit + " - " + limit + " dari " + this.rows + " entri";
    },
    start() {
      if (!this.isRunning) {
        this.startTime = Date.now() - this.elapsedTime;
        this.intervalId = setInterval(() => {
          this.elapsedTime = Date.now() - this.startTime;
        }, 10);
      }
    },
    pause() {
      clearInterval(this.intervalId);
      this.intervalId = null;
    },
    resetTime() {
      // this.pause();
      this.elapsedTime = 0;
      this.startTime = null;
      this.startTime = Date.now() - this.elapsedTime;
      this.intervalId = setInterval(() => {
        this.elapsedTime = Date.now() - this.startTime;
      }, 10);
      localStorage.removeItem("stopwatch");
    },
    async fetchWilayah() {
      try {
        const res = await this.$axios.get(`gadai/kode-wilayah-gadai-kendaraan`);
        const data = res.data;
        this.wilayahListOriginal = data;
        this.wilayahList = data.map((kode) => ({
          value: kode.name,
          text: kode.name,
        }));
      } catch (err) {
        this.$helper.parseError(this, err);
      }
    },

    openPreview(foto) {
      this.activeFotoPreview = foto;
      this.$bvModal.show("modal-preview-gadai");
    },
    redirectToWhatsapp(number) {
      if (!number || number === '-' || number.trim() === '') {
          return;
      }

      const formatted = number.startsWith('0') 
      ? '62' + number.substring(1) 
      : number;

      window.open(`https://wa.me/${formatted}`, '_blank');
    },
    onCopyUrlWhatsApp(number) {
      if (!number || number === '-' || number.trim() === '') {
          console.error('Nomor HP tidak valid untuk disalin.');
          return;
      }

      const formatted = number.startsWith('0') 
          ? '62' + number.substring(1) 
          : number;
      
      const urlToCopy = `https://wa.me/${formatted}`;

      navigator.clipboard.writeText(urlToCopy).then(() => {
          this.$helper.toastSucc(this, "Link WhatsApp berhasil disalin!")
      }).catch(err => {
          this.$helper.toastErr(this, "Gagal menyalin link.")
          console.error('Gagal menyalin teks: ', err);
      });
    },
    getListAnggota(noAnggota) {
      this.stateListAnggota.isLoading = true;
      this.stateListAnggota.isError = false;

      this.$axios.get(`nasabah/findForGadai`, {
          params: {
              query: noAnggota,
              searchBy: 3,
              page: 0,
              size: 10,
          }
      }).then(response => {
          const data = response.data.data[0];
          this.selectAnggota(data);
      })
      .catch(error => {
        this.$helper.parseError(this, error)
        this.stateListAnggota.isError = true;
      })
      .finally(() => {
        this.stateListAnggota.isLoading = false;
      })
    },
    onToastSuccesEdit() {
      this.$helper.toastSucc(this, "Identitas berhasil diupdate");
    },
    getMerkKendaraan() {
      const idJenisKendaraan = this.input.jenisKendaraan.id;
      this.optKendaraanMerk = [];
      this.stateMerkKendaraan.isLoading = true;
      this.$axios.get(`barang-merk/jenis/${idJenisKendaraan}`).then((response) => {
        this.optKendaraanMerk = response.data;
      }).catch((error) => {
        const errorMessage = error.response.data.reason || error.response.data.error;
        this.stateMerkKendaraan.error = errorMessage;
      }).finally(() => {
        this.stateMerkKendaraan.isLoading = false;
      }) 
    },
    getTipeKendaraan() {
      const idMerkKendaraan = this.input.merkKendaraan.id;
      this.optKendaraanTipe = [];
      this.stateTipeKendaraan.isLoading = true;

      this.$axios.get(`barang-tipe-v2/merk/${idMerkKendaraan}`).then((response) => {
        this.optKendaraanTipe = response.data.types;
      }).catch((error) => {
        const errorMessage = error.response.data.reason || error.response.data.error;
        this.stateTipeKendaraan.error = errorMessage;
      }).finally(() => {
        this.stateTipeKendaraan.isLoading = false;
      })
    },
    getTahunKendaraan() {
      const idTipeKendaraan = this.input.tipeKendaraan.id;
      this.optKendaraanTahun = [];
      this.stateTahunKendaraan.isLoading = true;

      this.$axios.get(`barang-tipe-v2/barang-tahun/${idTipeKendaraan}`).then((response) => {
        for (var x of response.data) {
          if (x.isActive == true) {
            this.optKendaraanTahun.push({
              id: x.id,
              name: x.tahun,
            });
          }
        }
      }).catch((error) => {
        const errorMessage = error.response.data.reason || error.response.data.error;
        this.stateTahunKendaraan.error = errorMessage;
      }).finally(() => {
        this.stateTahunKendaraan.isLoading = false;
      })
    },
    getGradeKendaraan() {
      const idTipeKendaraan = this.input.tipeKendaraan.id;
      this.optKendaraanKondisi = [];
      this.stateGradeKendaraan.isLoading = true;

      this.$axios.get(`barang-tipe-v2/kondisi/${idTipeKendaraan}`).then((response) => {
        let responseKondisi = response.data;
        responseKondisi = responseKondisi.filter((item) => item.isActive == true);
        for (let y = 0; y < responseKondisi.length; y++) {
          let dataKondisi = {};
          dataKondisi.value = responseKondisi[y].id;
          dataKondisi.text = responseKondisi[y].name.substring(4);
          this.optKendaraanKondisi.push(dataKondisi);
        }
      }).catch((error) => {
        const errorMessage = error.response.data.reason || error.response.data.error;
        this.stateGradeKendaraan.error = errorMessage;
      }).finally(() => {
        this.stateGradeKendaraan.isLoading = false;
      })
    },
    getKelengkapanKendaraan() {
      const idJenisKendaraan = this.input.jenisKendaraan.id;
      this.optKelengkapanKendaraan = [];
      this.stateKelengkapanKendaraan.isLoading = true;

      this.$axios.get(`barang-jenis/kelengkapan?jenisId=${idJenisKendaraan}`).then((response) => {
        for (var x of response.data) {
          if (x.isActive == true) {
            this.optKelengkapanKendaraan.push({
              id: x.id,
              name: x.name,
            });
          }
        }
      }).catch((error) => {
        const errorMessage = error.response.data.reason || error.response.data.error;
        this.stateKelengkapanKendaraan.error = errorMessage;
      }).finally(() => {
        this.stateKelengkapanKendaraan.isLoading = false;
      })
    },
    getSpesifikasiJenisKendaraan() {
      const idJenisKendaraan = this.input.jenisKendaraan.id;
      this.optKendaraanSpekJenis.penambahan = [];
      this.optKendaraanSpekJenis.pengurangan = [];
      this.stateSpesifikasiJenisKendaraan.isLoading = true;

      this.$axios.get(`barang-jenis/spesifikasi?jenisId=${idJenisKendaraan}`).then((response) => {
        for (var x of response.data.penambahan) {
          if (x.isActive == true) {
            var isViewSE = true;
            for (var file of x.suratEdaran) {
              if (file.isViewSE == "false") {
                isViewSE = false;
              }
            }
            this.optKendaraanSpekJenis.penambahan.push({
              id: x.id,
              name: x.name,
              nominalAngka: x.nominalAngka,
              nominalPersen: x.nominalPersen,
              se: x.suratEdaran.length != 0 ? x.suratEdaran : null,
              isViewSE: isViewSE,
            });
          }
        }
        for (var x of response.data.pengurangan) {
          if (x.isActive == true) {
            var isViewSE = true;
            for (var file of x.suratEdaran) {
              if (file.isViewSE == "false") {
                isViewSE = false;
              }
            }
            this.optKendaraanSpekJenis.pengurangan.push({
              id: x.id,
              name: x.name,
              nominalAngka: x.nominalAngka,
              nominalPersen: x.nominalPersen,
              se: x.suratEdaran.length != 0 ? x.suratEdaran : null,
              isViewSE: isViewSE,
            });
          }
        }
      }).catch((error) => {
        const errorMessage = error.response.data.reason || error.response.data.error;
        this.stateSpesifikasiJenisKendaraan.error = errorMessage;
      }).finally(() => {
        this.stateSpesifikasiJenisKendaraan.isLoading = false;
      })
    },
    getSpesifikasiMerkKendaraan() {
      const idMerkKendaraan = this.input.merkKendaraan.id;
      this.optKendaraanSpekMerk.penambahan = [];
      this.optKendaraanSpekMerk.pengurangan = [];
      this.stateSpesifikasiMerkKendaraan.isLoading = true;

      this.$axios.get(`barang-merk/spesifikasi?merkId=${idMerkKendaraan}`).then((response) => {
        for (var x of response.data.penambahan) {
          if (x.isActive == true) {
            var isViewSE = true;
            for (var file of x.suratEdaran) {
              if (file.isViewSE == "false") {
                isViewSE = false;
              }
            }

            this.optKendaraanSpekMerk.penambahan.push({
              id: x.id,
              name: x.name,
              se: x.suratEdaran.length != 0 ? x.suratEdaran : null,
              isViewSE: isViewSE,
              fotoSpesifikasi: x.fotoSpesifikasi,
              isActive: x.isActive,
              nominalAngka: x.nominalAngka,
              nominalPersen: x.nominalPersen,
            });
          }
        }

        for (var x of response.data.pengurangan) {
          if (x.isActive == true) {
            var isViewSE = true;
            for (var file of x.suratEdaran) {
              if (file.isViewSE == "false") {
                isViewSE = false;
              }
            }

            this.optKendaraanSpekMerk.pengurangan.push({
              id: x.id,
              name: x.name,
              se: x.suratEdaran.length != 0 ? x.suratEdaran : null,
              isViewSE: isViewSE,
              fotoSpesifikasi: x.fotoSpesifikasi,
              isActive: x.isActive,
              nominalAngka: x.nominalAngka,
              nominalPersen: x.nominalPersen,
            });
          }
        }
      }).catch((error) => {
        const errorMessage = error.response.data.reason || error.response.data.error;
        this.stateSpesifikasiMerkKendaraan.error = errorMessage;
      }).finally(() => {
        this.stateSpesifikasiMerkKendaraan.isLoading = false;
      })
    },
    normalizePajakMatiName(name) {
      return String(name || "").toUpperCase().replace(/\s+/g, " ").trim();
    },
    getPajakMatiNameMapping() {
      return {
        sendiriRegular: [
          "Pajak Mati (a/n Sendiri)",
          "Pajak Mati (a/n SENDIRI)",
        ],
        orangLainRegular: [
          "Pajak Mati (a/n Orang lain)",
          "Pajak Mati (a/n ORANG LAIN)",
        ],
        sendiriPickUp: [
          "Pajak Mati (a/n Sendiri Pick Up)",
          "Pajak Mati (a/n SENDIRI PICK UP)",
        ],
        orangLainPickUp: [
          "Pajak Mati (a/n Orang Lain Pick Up)",
          "Pajak Mati (a/n Orang lain Pick Up)",
          "Pajak Mati (a/n ORANG LAIN PICK UP)",
        ],
      };
    },
    getAllPajakMatiIds() {
      const mapping = this.getPajakMatiNameMapping();
      const allNames = Object.values(mapping).flat().map((item) => this.normalizePajakMatiName(item));
      return this.optKendaraanSpekJenis.pengurangan
        .filter((item) => allNames.includes(this.normalizePajakMatiName(item.name)))
        .map((item) => item.id);
    },
    getCurrentPajakMatiIdsByKondisi() {
      if (!this.input.kondisiKendaraan || !this.input.tipeKendaraan) return [];

      const isPickUp = this.input.tipeKendaraan.name === "Pick Up";
      const kondisi = this.normalizePajakMatiName(this.input.kondisiKendaraan.text);
      const isOrangLain = kondisi.includes("A/N ORANG LAIN");
      const mapping = this.getPajakMatiNameMapping();

      const targetNames = isPickUp
        ? (isOrangLain ? mapping.orangLainPickUp : mapping.sendiriPickUp)
        : (isOrangLain ? mapping.orangLainRegular : mapping.sendiriRegular);

      const normalizedTarget = targetNames.map((item) => this.normalizePajakMatiName(item));
      return this.optKendaraanSpekJenis.pengurangan
        .filter((item) => normalizedTarget.includes(this.normalizePajakMatiName(item.name)))
        .map((item) => item.id);
    },
    clearPajakMatiSelection() {
      const allPajakMatiIds = this.getAllPajakMatiIds();
      this.input.spesifikasiKendaraanJenis = this.input.spesifikasiKendaraanJenis
        .filter((item) => !allPajakMatiIds.includes(item));
    },
    applyPajakMatiByStnkDate(stnkDate) {
      this.clearPajakMatiSelection();
      if (!stnkDate) return;

      const dateStnk = new Date(stnkDate.toString());
      if (Number.isNaN(dateStnk.getTime())) return;

      const today = new Date();
      today.setHours(0, 0, 0, 0);
      dateStnk.setHours(0, 0, 0, 0);

      if (dateStnk > today) return;

      const targetIds = this.getCurrentPajakMatiIdsByKondisi();
      this.input.spesifikasiKendaraanJenis = [
        ...new Set([...this.input.spesifikasiKendaraanJenis, ...targetIds]),
      ];
    },
    isEmptyState(fieldValue) {
      if (!fieldValue) return true;
      const selectedOption = Array.isArray(fieldValue) ? fieldValue[0] : fieldValue;
      return !selectedOption || (selectedOption.id === null && selectedOption.name === null);
    },
    showModalConfirmEditAnggota(value) {
      this.selectedRow = value;
      
      if (this.$helper.isNullOrEmpty(value.notes)) {
        this.$helper.toastErr(this, "Mohon isi alasan terlebih dahulu.")
        return
      }

      if (value.key === 'no-handphone') {
        const isOldValueX = value.oldValue && String(value.oldValue).toLowerCase().startsWith('x');
        
        if (!isOldValueX && this.$helper.isNullOrEmpty(value.attachments)) {
          this.$helper.toastErr(this, "Mohon isi foto pendukung terlebih dahulu.")
          return
        }
          
        this.$bvModal.show('modal-request-edit-no-handphone')
      }

      if (value.key === 'name') {
        this.$bvModal.show('modal-request-edit-name')
      }
    },
    handleApproval(field) {
      const value = this.selectedRow;
      const cabangId = localStorage.getItem('activeCabangId');

      const payload = new URLSearchParams();

      if (field === 'no-handphone') {
        const attachmentsValue = Array.isArray(value.attachments) 
          ? JSON.stringify(value.attachments) 
          : value.attachments;
                
        payload.append('attachments', attachmentsValue);
      }

      let dataType = '';
      if (field === 'no-handphone') {
        dataType = 'no_handphone_sekarang'
      }

      if (field === 'name') {
        dataType = 'nama'
      }

      this.isLoadingReqApproval = true

      const params = {
        dataType: dataType,
        value: value.newValue,
        note: value.notes,
        nasabahId: value.row.id,
        cabangId: cabangId,
      };

      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
      };

      this.$axios.post('/nasabah/request-update-data', payload, { 
        params: params, 
        headers: headers 
      })
      .then(response => {
        this.$helper.toastSucc(this, response.data.name)
        if (field === 'no-handphone') {
          this.$bvModal.hide('modal-approval-no-handphone')
          this.$bvModal.hide('modal-request-edit-no-handphone')
        }

        if (field === 'name') {
          this.$bvModal.hide('modal-approval-name')
          this.$bvModal.hide('modal-request-edit-name')
        }
      })
      .catch(error => {
        this.$helper.parseError(this, error)
      })
      .finally(() => {
        this.isLoadingReqApproval = false;
      })
    }
  },
  watch: {
    "anggota.alamat": function (newVal) {
      this.checkNasabah();
    },

    "input.jenisKendaraan": function (newVal) {
      if (this.shouldResetSelections == true) {
        this.optKendaraanMerk = [];
        this.input.merkKendaraan = { id: null, name: null };

        this.optKelengkapanKendaraan = [];
        this.input.kelengkapanKendaraan = [];

        this.optKendaraanSpekJenis = {
          penambahan: [],
          pengurangan: [],
        };
        this.input.spesifikasiKendaraanJenis = [];

        this.optPromo = [];
        this.input.promo = [];
        this.isPromoRetrieved = false;
      }

      this.seMerk = null;
      this.seTipe = null;
      this.seKondisi = null;
      this.showSeKondisi = null;

      this.input.dataStnk.submitMasaBerlakuStnk = "";

      if (newVal.id == undefined) {
        return;
      }

      if (newVal.name == "Mobil") {
        this.$bvModal.show("modal-confirm-lanjutGadai");
      }

      if (newVal.id != undefined) {
        if (this.input.jenisKendaraan.name.startsWith("Lainnya")) {
          this.showDataLainnya = true;
        }
        // Lookup Merk
        this.getMerkKendaraan();

        // Loojup SE jenis
        this.$axios.get(`barang-jenis/${newVal.id}`).then((response) => {
          if (response.data.suratEdaran.length != 0) {
            this.seJenis = response.data.suratEdaran;

            for (var se of this.seJenis) {
              if (se.isViewSE == "false") {
                this.pdfReadJenis = false;
              }
            }
          } else {
            this.seJenis = null;
          }
        });

        // Lookup Kelengkapan Kendaraan
        this.getKelengkapanKendaraan();

        // LookUP Se Kelengkapan
        this.$axios
          .get("/surat-edaran/list/?menu=kelengkapan" + newVal.id + "&jenis=kelengkapan")
          .then((response) => {
            if (response.data.length != 0) {
              this.seKelengkapan = response.data;
              for (var file of this.seKelengkapan) {
                if (file.isViewSE == "false") {
                  this.pdfReadKelengkapan = false;
                }
              }
            }
          });

        // Lookup Spek Jenis
        this.getSpesifikasiJenisKendaraan();
      }

      if (newVal != null && this.anggota.id != null) {
        this.$axios
          .get(
            `/gadai-crud/check-gadai-limits?nasabahId=${this.anggota.id}&jenisBarangId=${newVal.id}`
          )
          .then((response) => {})
          .catch((error) => {
            this.$helper.parseError(this, error);
          });
      }
    },

    "input.merkKendaraan": function (newVal) {
      if (this.shouldResetSelections == true) {
        this.optKendaraanTipe = [];
        this.input.tipeKendaraan = null;

        this.optKendaraanSpekMerk = {
          penambahan: [],
          pengurangan: [],
        };

        this.input.spesifikasiKendaraanMerk = [];

        this.optPromo = [];
        this.input.promo = [];
        this.isPromoRetrieved = false;
      }

      this.shouldResetSelections = true;

      this.seTipe = null;
      this.seKondisi = null;
      this.showSeKondisi = null;

      if (newVal.id == undefined) {
        return;
      }

      if (newVal.id != undefined) {
        // Lookup Tipe
        this.getTipeKendaraan();

        // Loojup SE Merk
        this.$axios.get(`barang-merk/${newVal.id}`).then((response) => {
          if (response.data.suratEdaran.length != 0) {
            this.seMerk = response.data.suratEdaran;
            for (var se of this.seMerk) {
              if (se.isViewSE == "false") {
                this.pdfReadMerk = false;
              }
            }
          } else {
            this.seMerk = null;
          }

          if (response.data.kondisi[0].suratEdaran.length != 0) {
            let suratEdaranKondisi = [];
            for (var se of response.data.kondisi[0].suratEdaran) {
              suratEdaranKondisi.push(se);
              if (se.isViewSE == "false") {
                this.pdfReadKondisi = false;
              }
            }

            this.seKondisi = suratEdaranKondisi;
            this.seKondisiDariMerk = true;
          } else {
            this.seKondisi = null;
          }
        });

        // Lookup Spek Merk
        this.getSpesifikasiMerkKendaraan();
      }
    },

    "input.tipeKendaraan": function (newVal) {
      if (this.shouldResetSelections == true) {
        this.optKendaraanTahun = [];
        this.input.tahunKendaraan = null;

        this.optKendaraanKondisi = [];
        // if(!this.isFromSimulasi){
        this.input.kondisiKendaraan = null;
        // }
        this.optPromo = [];
        this.input.promo = [];
        this.isPromoRetrieved = false;
      }

      this.shouldResetSelections = true;

      if (this.optKendaraanSpekJenis.pengurangan.length != 0) {
        let idx = this.optKendaraanSpekJenis.pengurangan.findIndex(
          (item) =>
            item.name == "Pajak Mati (a/n Orang lain)" ||
            item.name == "Pajak Mati (a/n ORANG LAIN)"
        );
        let idx2 = this.optKendaraanSpekJenis.pengurangan.findIndex(
          (item) =>
            item.name == "Pajak Mati (a/n Sendiri)" ||
            item.name == "Pajak Mati (a/n SENDIRI)"
        );
        let idx3 = this.optKendaraanSpekJenis.pengurangan.findIndex(
          (item) =>
            item.name == "Pajak Mati (a/n Orang Lain Pick Up)" ||
            item.name == "Pajak Mati (a/n ORANG LAIN PICK UP)"
        );
        let idx4 = this.optKendaraanSpekJenis.pengurangan.findIndex(
          (item) =>
            item.name == "Pajak Mati (a/n Sendiri Pick Up)" ||
            item.name == "Pajak Mati (a/n SENDIRI PICK UP)"
        );

        this.input.spesifikasiKendaraanJenis = this.input.spesifikasiKendaraanJenis.filter(
          (item) => item != this.optKendaraanSpekJenis.pengurangan[idx].id
        );
        this.input.spesifikasiKendaraanJenis = this.input.spesifikasiKendaraanJenis.filter(
          (item) => item != this.optKendaraanSpekJenis.pengurangan[idx2].id
        );
        this.input.spesifikasiKendaraanJenis = this.input.spesifikasiKendaraanJenis.filter(
          (item) => item != this.optKendaraanSpekJenis.pengurangan[idx3].id
        );
        this.input.spesifikasiKendaraanJenis = this.input.spesifikasiKendaraanJenis.filter(
          (item) => item != this.optKendaraanSpekJenis.pengurangan[idx4].id
        );
      }

      if (newVal == null) {
        return;
      }

      if (newVal != null) {
        this.isLoadingHasTahun = true;
        this.$axios.get(`barang-tipe-v2/${newVal.id}`).then((response) => {
          if (response.data.suratEdaran.length != 0) {
            let suratEdaran = [];
            let suratEdaranKondisi = [];
            let suratEdaranTahun = [];
            for (var se of response.data.suratEdaran) {
              if (se.jenis == null || se.jenis == "tipe") {
                suratEdaran.push(se);
                if (se.isViewSE == "false") {
                  this.pdfReadTipe = false;
                }
              }
              if (se.jenis == "kondisi") {
                suratEdaranKondisi.push(se);
                if (se.isViewSE == "false") {
                  this.pdfReadKondisi = false;
                }
                this.seKondisiDariMerk = false;
              }
              if (se.jenis == "tahun") {
                suratEdaranTahun.push(se);
                if (se.isViewSE == "false") {
                  this.pdfReadTahun = false;
                }
              }
            }

            if (suratEdaranKondisi != null && suratEdaranKondisi.length != 0) {
              this.seKondisi = suratEdaranKondisi;
            }

            this.seTipe = suratEdaran;
            this.seTahun = suratEdaranTahun;
            this.showSeKondisi = true;

            if (suratEdaran.length == 0) {
              this.seTipe = null;
            }
            if (suratEdaranTahun.length == 0) {
              this.seTahun = null;
            }
          }

          if (response.data.hasTahun == true) {
            // Lookup Tahun
            this.getTahunKendaraan();
          }
        }).finally(() => {
          this.isLoadingHasTahun = false;
        });

        // Lookup Kondisi
        this.getGradeKendaraan();
      }
    },

    "input.tahunKendaraan": function (newVal) {
      if (this.shouldResetSelections == true) {
        this.optPromo = [];
        this.input.promo = [];
        this.isPromoRetrieved = false;
      }
    },

    boxSatu: function (newValue) {
      const result = newValue.replace(/[^a-zA-Z]/g, "").replace(/\s/g, "");
      this.$nextTick(() => (this.boxSatu = result));
    },
    boxDua: function (newValue) {
      const result = newValue.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, "");
      this.$nextTick(() => (this.boxDua = result));
    },
    boxTiga: function (newValue) {
      const result = newValue.replace(/[^a-zA-Z]/g, "").replace(/\s/g, "");
      this.$nextTick(() => (this.boxTiga = result));
    },

    "input.kondisiKendaraan": function (newVal) {
      this.applyPajakMatiByStnkDate(this.input.dataStnk.masaBerlakuStnk);
      this.isFromSimulasi = false;
    },
    //----------------- Cek Masa Berlaku STNK -----------------
    "input.dataStnk.masaBerlakuStnk": function (x) {
      this.input.dataStnk.submitMasaBerlakuStnk = this.$helper.validasiStnk(x);
      if (this.input.dataStnk.submitMasaBerlakuStnk == false) {
        this.clearPajakMatiSelection();
        this.$helper.toastErr(
          this,
          "Maaf Masa berlaku STNK lebih dari 6 bulan, tidak bisa melakukan gadai."
        );
        return;
      }

      this.applyPajakMatiByStnkDate(this.input.dataStnk.masaBerlakuStnk);
    },

    "anggota.id": function (newVal) {
      if (newVal == null) {
        return;
      }
      if (newVal && this.input.jenisBarang.id != null) {
        this.$axios
          .get(
            `/gadai-crud/check-gadai-limits?nasabahId=${newVal}&jenisBarangId=${this.input.jenisBarang.id}`
          )
          .then((response) => {})
          .catch((error) => {
            this.$helper.parseError(this, error);
          });
      }
    },
  },
  created() {
    this.resetTime();
    this.start();
    this.init();
    this.fetchWilayah();
  },
};
</script>
